import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { buildDropdownAudit, fetchData, fetchFormData, getEncryptedRoute, getTranslatedValue, hasSpecialCharacters, isOnlyNumber, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../reusable'
import { PageTitle } from '../../../_metronic/layout/core'
import { Modal } from 'react-bootstrap'
import Select from 'react-select';
import { MixedWidget17 } from '../../../_metronic/partials/widgets'
import Swal from 'sweetalert2'
import { AddHotelHeader } from './AddHotelHeader'
import clsx from 'clsx'
import { SortableUploadedImages, SortableNewImages } from '../components/SortableUploadedImages'
import { Calendar, Views, momentLocalizer, SlotInfo, CalendarProps } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { config } from '../../../reusable'
import JoditEditor from 'jodit-react';
import imageCompression from 'browser-image-compression';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { KTIcon } from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'
import PriceInput from '../components/PriceInput'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const ViewRooms: FC = () => {
  const { menuId, menuIdEdit, menuIdDelete } = useMenuIdPermissions()

  const tmp = sessionStorage.getItem('admin')
const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''

  const t = Tr()
  const lang = useLang()
  const editorRefEN = useRef(null)
  const editorRefRU = useRef(null)
  const editorRefUZ = useRef(null)
  const editorConfig = useMemo(() => config(), [])
  const inputfileRef = useRef(null);
  const location = useLocation();
  const [loading, setLoading] = useState(false)
  const editHotelId = (location.state as any)?.hotelId || '';

  const primaryLanguage = sessionStorage.getItem("primaryLanguage");
  // -------- state start ------------ 
  const [editRoomId, setEditRoomId] = useState("");
  const [tab, setTab] = useState('BasicInfo') // BasicInfo, GeneralInfo, FacilityAndServices, PricingAndAvailability, RoomPhotos
  const [priceTab, setPriceTab] = useState('RegularPrice') // RegularPrice, SpecialPrice, Availability
  const [disable, setDisable] = useState(false);
  const [hotelDetail, setHotelDetail] = useState([]);
  const [hotelDetails, setHotelDetails] = useState([]);
  const [primLanguage, setPrimLanguage] = useState("");
  const [roomNameEN, setRoomNameEN] = useState("");
  const [roomNameRU, setRoomNameRU] = useState("");
  const [roomNameUZ, setRoomNameUZ] = useState("");
  const [generalInformationEN, setGeneralInformationEN] = useState("");
  const [generalInformationRU, setGeneralInformationRU] = useState("");
  const [generalInformationUZ, setGeneralInformationUZ] = useState("");
  const [maxPeople, setMaxPeople] = useState("");
  const [baseCharge, setBaseCharge] = useState("");
  const [baseChargeByHours, setBaseChargeByHours] = useState("");
  const [extraAdultChargeByDay, setExtraAdultChargeByDay] = useState("");
  const [extraAdultChargeByHours, setExtraAdultChargeByHours] = useState("");
  const [availableRoom, setAvailableRoom] = useState("");
  const [standardPeople, setStandardPeople] = useState("");
  const [isSmokingAllowed, setIsSmokingAllowed] = useState("No");
  const [numberOfBathroom, setNumberOfBathroom] = useState("");
  const [byDay, setByDay] = useState(true);
  const [byHours, setByHours] = useState(true);
  const [fromAvailableHours, setFromAvailableHours] = useState("");
  const [toAvailableHours, setToAvailableHours] = useState("");
  const [startAvailableDate, setStartAvailableDate] = useState("");
  const [endAvailableDate, setEndAvailableDate] = useState("");
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [en_title, setEn_title] = useState("");
  const [ru_title, setRu_title] = useState("");
  const [uz_title, setUz_title] = useState("");
  const [hourlyType, setHourlyType] = useState("Hourly");
  const [dailyType, setDailyType] = useState("Daily");
  const [hourlyMondayPrice, setHourlyMondayPrice] = useState("0");
  const [hourlyTuesdayPrice, setHourlyTuesdayPrice] = useState("0");
  const [hourlyWednedayPrice, setHourlyWednesdayPrice] = useState("0");
  const [hourlyThurdayPrice, setHourlyThursdayPrice] = useState("0");
  const [hourlyFridayPrice, setHourlyFridayPrice] = useState("0");
  const [hourlySaturdayPrice, setHourlySaturdayPrice] = useState("0");
  const [hourlySundayPrice, setHourlySundayPrice] = useState("0");
  const [dailyMondayPrice, setDailyMondayPrice] = useState("0");
  const [dailyTuesdayPrice, setDailyTuesdayPrice] = useState("0");
  const [dailyWednedayPrice, setDailyWednesdayPrice] = useState("0");
  const [dailyThurdayPrice, setDailyThursdayPrice] = useState("0");
  const [dailyFridayPrice, setDailyFridayPrice] = useState("0");
  const [dailySaturdayPrice, setDailySaturdayPrice] = useState("0");
  const [dailySundayPrice, setDailySundayPrice] = useState("0");
  const [specialPrice, setSpecialPrice] = useState([]) as any;
  const [checkInTime, setCheckInTime] = useState('')
  const [checkOutTime, setCheckOutTime] = useState('')
  const [editIndex, setEditIndex] = useState(-1);

  const handleByDayChange = (e: any) => {
    setByDay(e.target.checked); // Toggle the checked state
  };
  const handleByHoursChange = (e: any) => {
    setByHours(e.target.checked); // Toggle the checked state
  };
  const [inputImage, setInputImage] = useState([]) as any;
  const [uploadedImage, setUploadedImage] = useState([]);

  // handle modal show & hide
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false)
    setEditRoomId("");
    cleanStates();
  };
  const handleShow = () => setShow(true);
  const [showInfo, setShowInfo] = useState(false);
  const handleCloseInfo = () => setShowInfo(false);
  const handleShowInfo = () => setShowInfo(true);

  // amenities list state start
  const [amenitiesList, setAmenitiesList] = useState([]);
  const [amenitiesSelectedOptions, setAmenitiesSelectedOptions] = useState<any>([]);
  const amenityId = amenitiesSelectedOptions ? amenitiesSelectedOptions.map((option: any) => option.value).join(',') : "";
  // amenities list state end
  // room type list state start
  const [roomTypeList, setRoomTypeList] = useState([]);
  const [roomTypeSelectedOptions, setRoomTypeSelectedOptions] = useState<any>();
  // room type list state end

  // room type list state start
  const [bedTypeList, setBedTypeList] = useState([]);
  const [bedTypeSelectedOptions, setBedTypeSelectedOptions] = useState<any>();
  // room type list state end
  // available type list state start
  const [availableTypeList] = useState([
    { label: 'available', value: 'available' },
    { label: 'unavailable', value: 'unavailable' },
  ]);
  const [availableTypeSelectedOptions, setAvailableTypeSelectedOptions] = useState<any>();

  // available type list state end
  // bathroom type list state start
  const [bathroomTypeList, setBathroomTypeList] = useState([]);
  const [bathroomTypeSelectedOptions, setBathroomTypeSelectedOptions] = useState<any>();
  // bathroom type list state end
  const [oldRoomTypeSelectedOptions, setOldRoomTypeSelectedOptions] = useState<any>(null)
  const [oldBedTypeSelectedOptions, setOldBedTypeSelectedOptions] = useState<any>(null)
  const [oldBathroomTypeSelectedOptions, setOldBathroomTypeSelectedOptions] = useState<any>(null)
  const [oldAmenitiesSelectedOptions, setOldAmenitiesSelectedOptions] = useState<any>(null)

  const [offset, setoffset] = useState(0)
  const [limit, setlimit] = useState(9);
  const [page, setpage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [from, setfrom] = useState(1)
  const [to, setTo] = useState(1)
  const [displayRoomList, setDisplayRoomList] = useState([]);
  const [pageNumbersList, setPageNumberList] = useState([1])
  const [validationErrors, setValidationErrors] = useState([{
    en_title: '',
    ru_title: '',
    uz_title: '',
    fromDate: '',
    toDate: '',
    hourlyMondayPrice: '',
    hourlyTuesdayPrice: '',
    hourlyWednedayPrice: '',
    hourlyThurdayPrice: '',
    hourlyFridayPrice: '',
    hourlySaturdayPrice: '',
    hourlySundayPrice: '',
    dailyMondayPrice: '',
    dailyTuesdayPrice: '',
    dailyWednedayPrice: '',
    dailyThurdayPrice: '',
    dailyFridayPrice: '',
    dailySaturdayPrice: '',
    dailySundayPrice: '',
  }]);

  const [error, setError] = useState([{
    roomNameEN: '',
    roomNameRU: '',
    roomNameUZ: '',
    generalInformationEN: '',
    generalInformationRU: '',
    generalInformationUZ: '',
    maxPeople: '',
    amenityId: '',
    roomTypeId: '',
    roomViewId: '',
    bedTypeId: '',
    bathroomTypeId: '',
    baseCharge: '',
    baseChargeByHours: '',
    extraAdultChargeByDay: '',
    extraChildChargeByDay: '',
    extraAdultChargeByHours: '',
    extraChildChargeByHours: '',
    strikePrice: '',
    availableRoom: '',
    standardPeople: '',
    numberOfBathroom: '',
    fromAvailableHours: '',
    toAvailableHours: '',
    bookingType: '',
    availableDate: '',
    inputImage: '',
  }])
  // ----------- state end ------------

  // ----------------------- functions ---------------------------- 
  // page number generater
  function generatePageNumbers(currentPage: any, totalPages: any, maxPagesToShow: any) {
    const halfMaxPages = Math.floor(maxPagesToShow / 2);
    let startPage = Math.max(1, currentPage - halfMaxPages);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    // Adjust startPage and endPage if the total pages to show is less than maxPagesToShow
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    // Generate the list of page numbers
    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  }
  // on page change function
  const onPageChange = (pageId: any) => {
    if (pageId != page && pageId != 0 && pageId <= totalPage) {
      var tmp = (pageId - 1) * limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp + 1)
      // setto
      var mod = hotelDetails.length % limit
      var tolimi: any = limit
      if (mod > 0) {
        if (mod <= limit) {
          tolimi = pageId * limit

        }
        else {
          tolimi = pageId * limit + limit
        }
      }
      else {
        tolimi = pageId * limit
      }
      setTo(tolimi)
      var tmpdata: any = hotelDetails.slice(tmp, tolimi)
      setDisplayRoomList(tmpdata)
    }

  }
  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any;
    tmp[0][err] = "";
    setError(tmp);
  }
  const clearValidationError = (err: any) => {
    var tmp = [...validationErrors] as any;
    tmp[0][err] = "";
    setValidationErrors(tmp);
  };

  const formatDate = (date: any) => {
    return moment(date).format('DD-MM-YYYY h:mm A');
  };

  const checkDateConflict = () => {
    for (let i = 0; i < specialPrice.length; i++) {
      // Skip checking the date conflict for the row being edited
      if (editIndex > -1 && i === editIndex) {
        continue;
      }
      const existingItem = specialPrice[i];
      const existingFromDate = new Date(existingItem.fromDate);
      const existingToDate = new Date(existingItem.toDate);
      const currentFromDate = new Date(fromDate);
      const currentToDate = new Date(toDate);
      // Check if the current date range overlaps with any other existing date range
      if (
        (currentFromDate >= existingFromDate && currentFromDate <= existingToDate) ||
        (currentToDate >= existingFromDate && currentToDate <= existingToDate) ||
        (currentFromDate <= existingFromDate && currentToDate >= existingToDate)
      ) {
        toasterrormsg(t("Date conflict: The selected date range overlaps with an existing entry."));
        return false;
      }
    }
    return true;
  };

  const validateSpecialPrice = () => {
    let isValid = true;
    const errorTmp = [...validationErrors];

    if (primaryLanguage === 'English') {
      if (!en_title.trim()) {
        errorTmp[0].en_title = t('Title Is Required');
        isValid = false;
      } else if (!hasSpecialCharacters(en_title.trim())) {
        errorTmp[0].en_title = t('Special Characters Are Not Allowed');
        isValid = false;
      }
    } else if (primaryLanguage === 'Russian') {
      if (!ru_title.trim()) {
        errorTmp[0].ru_title = t('Title Is Required');
        isValid = false;
      } else if (!hasSpecialCharacters(ru_title.trim())) {
        errorTmp[0].ru_title = t('Special Characters Are Not Allowed');
        isValid = false;
      }
    } else if (primaryLanguage === 'Uzbek') {
      if (!uz_title.trim()) {
        errorTmp[0].uz_title = t('Title Is Required');
        isValid = false;
      } else if (!hasSpecialCharacters(uz_title.trim())) {
        errorTmp[0].uz_title = t('Special Characters Are Not Allowed');
        isValid = false;
      }
    }

    if (!fromDate && fromDate != '0') {
      errorTmp[0].fromDate = t('Start Date Is Required.');
      isValid = false;
    }
    if (!toDate && toDate != '0') {
      errorTmp[0].toDate = t('End Date Is Required.');
      isValid = false;
    }
    if (toDate != "" && fromDate != "" && toDate < fromDate) {
      errorTmp[0].toDate = t("End Date Can't Be Smaller Than Start Date.")
      isValid = false
    }
    if (moment(fromDate).isBefore(moment().startOf('day'))) {
      errorTmp[0].fromDate = t("Start Date Can't Be In The Past.")
      isValid = false
    }
    if (!hourlyMondayPrice && hourlyMondayPrice != '0') {
      errorTmp[0].hourlyMondayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!hourlyTuesdayPrice && hourlyTuesdayPrice != '0') {
      errorTmp[0].hourlyTuesdayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!hourlyWednedayPrice && hourlyWednedayPrice != '0') {
      errorTmp[0].hourlyWednedayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!hourlyThurdayPrice && hourlyThurdayPrice != '0') {
      errorTmp[0].hourlyThurdayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!hourlyFridayPrice && hourlyFridayPrice != '0') {
      errorTmp[0].hourlyFridayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!hourlySaturdayPrice && hourlySaturdayPrice != '0') {
      errorTmp[0].hourlySaturdayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!hourlySundayPrice && hourlySundayPrice != '0') {
      errorTmp[0].hourlySundayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!dailyMondayPrice && dailyMondayPrice != '0') {
      errorTmp[0].dailyMondayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!dailyTuesdayPrice && dailyTuesdayPrice != '0') {
      errorTmp[0].dailyTuesdayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!dailyWednedayPrice && dailyWednedayPrice != '0') {
      errorTmp[0].dailyWednedayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!dailyThurdayPrice && dailyThurdayPrice != '0') {
      errorTmp[0].dailyThurdayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!dailyFridayPrice && dailyFridayPrice != '0') {
      errorTmp[0].dailyFridayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!dailySaturdayPrice && dailySaturdayPrice != '0') {
      errorTmp[0].dailySaturdayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!dailySundayPrice && dailySundayPrice != '0') {
      errorTmp[0].dailySundayPrice = t('Price Is Required.');
      isValid = false;
    }

    setValidationErrors(errorTmp);
    return isValid;
  };
  const handleSave = () => {
    if (!validateSpecialPrice()) {
      return;
    }
    if (!checkDateConflict()) {
      return;
    }
    const newData = {
      fromDate,
      toDate,
      en_title,
      ru_title,
      uz_title,
      hourlyType,
      dailyType,
      hourlyMondayPrice,
      hourlyTuesdayPrice,
      hourlyWednedayPrice,
      hourlyThurdayPrice,
      hourlyFridayPrice,
      hourlySaturdayPrice,
      hourlySundayPrice,
      dailyMondayPrice,
      dailyTuesdayPrice,
      dailyWednedayPrice,
      dailyThurdayPrice,
      dailyFridayPrice,
      dailySaturdayPrice,
      dailySundayPrice,
    };

    if (editIndex > -1) {
      const updatedData = specialPrice.map((item: any, index: any) => (index === editIndex ? newData : item));
      setSpecialPrice(updatedData);
      setEditIndex(-1);
    } else {
      setSpecialPrice([...specialPrice, newData]);
    }

    resetForm();
  };

  const handleEdit = (index: any) => {
    const item = specialPrice[index];
    setFromDate(item.fromDate);
    setToDate(item.toDate);
    setEn_title(item.en_title);
    setRu_title(item.ru_title);
    setUz_title(item.uz_title);
    setHourlyType(item.hourlyType);
    setDailyType(item.dailyType);
    setHourlyMondayPrice(item.hourlyMondayPrice);
    setHourlyTuesdayPrice(item.hourlyTuesdayPrice);
    setHourlyWednesdayPrice(item.hourlyWednedayPrice);
    setHourlyThursdayPrice(item.hourlyThurdayPrice);
    setHourlyFridayPrice(item.hourlyFridayPrice);
    setHourlySaturdayPrice(item.hourlySaturdayPrice);
    setHourlySundayPrice(item.hourlySundayPrice);
    setDailyMondayPrice(item.dailyMondayPrice);
    setDailyTuesdayPrice(item.dailyTuesdayPrice);
    setDailyWednesdayPrice(item.dailyWednedayPrice);
    setDailyThursdayPrice(item.dailyThurdayPrice);
    setDailyFridayPrice(item.dailyFridayPrice);
    setDailySaturdayPrice(item.dailySaturdayPrice);
    setDailySundayPrice(item.dailySundayPrice);
    setEditIndex(index);
  };

  const handleRemove = (index: any) => {
    setSpecialPrice(specialPrice.filter((_: any, i: any) => i !== index));
    resetForm();
  };

  const resetForm = () => {
    setFromDate('');
    setToDate('');
    setEn_title("");
    setRu_title("");
    setUz_title("");
    setHourlyType("Hourly");
    setDailyType("Daily");
    setHourlyMondayPrice("0");
    setHourlyTuesdayPrice("0");
    setHourlyWednesdayPrice("0");
    setHourlyThursdayPrice("0");
    setHourlyFridayPrice("0");
    setHourlySaturdayPrice("0");
    setHourlySundayPrice("0");
    setDailyMondayPrice("0");
    setDailyTuesdayPrice("0");
    setDailyWednesdayPrice("0");
    setDailyThursdayPrice("0");
    setDailyFridayPrice("0");
    setDailySaturdayPrice("0");
    setDailySundayPrice("0");
    setEditIndex(-1);
  };
  const handleImageChange = async (e: any) => {
    removeError("inputImage");
    const selectedFiles = Array.from(e.target.files);

     const validFiles = selectedFiles.filter((file: any) => {
          if (file.size > 5 * 1024 * 1024) { // 5 MB = 5 * 1024 * 1024 bytes
            toasterrormsg(`${file.name} is larger than 5 MB and was not added.`);
            return false;
          }
          return true;
        });
    // Check if adding selected files will exceed the limit
    if (inputImage.length + validFiles.length > 15) {
      // If it exceeds, only select files up to the limit
      const remainingCapacity = 15 - inputImage.length;
      const limitedFiles = validFiles.slice(0, remainingCapacity);

      // Display a message or perform an action to notify the user about the limit
      toasterrormsg(t("Maximum 15 Images Can Be Uploaded."));

      // Compress the images
      const processedFiles = await Promise.all(
        limitedFiles.map((file: any) => processImage(file))
      );

      // Store the processed file names as paths
      const filePaths = processedFiles.map((file) => file);

      // Append new images to the existing array of images
      setInputImage((prevImages: any) => [...prevImages, ...filePaths]);
    } else {
      // If it doesn't exceed, proceed as before
      const processedFiles = await Promise.all(
        validFiles.map((file: any) => processImage(file))
      );
      const filePaths = processedFiles.map((file) => file);
      setInputImage((prevImages: any) => [...prevImages, ...filePaths]);
    }
  };

  const processImage = async (imageFile: File) => {
    if (imageFile.size >= 2 * 1024 * 1024) {
      return await compressImage(imageFile);
    } else {
      return imageFile;
    }
  };

  const compressImage = async (imageFile: File) => {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1024,
      useWebWorker: true
    };
    try {
      const compressedBlob = await imageCompression(imageFile, options);
      const extension = imageFile.name.split('.').pop();
      const newFileName = `${Date.now()}.${extension}`;
      const compressedFile = new File([compressedBlob], newFileName, {
        type: compressedBlob.type,
        lastModified: Date.now()
      });
      return compressedFile;
    } catch (error) {
      console.error('Error compressing image:', error);
      return imageFile;
    }
  };

  // function for remove selected images
  const handleRemove1 = (index1: any) => {

    let tmparrimg = inputImage.filter((item: any, index: any) => index != index1)

    setInputImage(tmparrimg);

  };

  // remove uplaoded images
  const handleRemoveImage = async (index: any) => {

    var param = {
      'hotelmediaId': index,
      adminId:adminId
    }
    var res = await fetchData("vendor/public/deleteHotelMedia", param)

    if (res.status == "200") {
      hotelDetailsApiCall()
    }
    else {
      toasterrormsg(res.message)
    }
  };

  const handleTextClick = () => {

    let element: HTMLElement = document.getElementsByClassName('modaldocument')[0] as HTMLElement;
    element.click();

  };


  function timeStrToMinutes(timeStr: string): number {
    if (!timeStr) return 0;
    const parts = timeStr.split(':').map(Number);
    const hours = parts[0] || 0;
    const minutes = parts[1] || 0;
    return hours * 60 + minutes;
  }

  function isTimeInReservedRange(
    availableFromMin: number,
    availableToMin: number,
    checkInMin: number,
    checkOutMin: number
  ): boolean {
    // Handle case where check-out time is next day (crosses midnight)
    if (checkOutMin <= checkInMin) {
      // Reserved time spans midnight (e.g., 9:00 to 24:00 means 9:00 to 00:00 next day)
      // Check if available time overlaps with either:
      // 1. From check-in to midnight (540-1440 for 9AM-24:00)
      // 2. From midnight to check-out (0-checkOutMin for 00:00-checkOut)

      const overlapBeforeMidnight = (availableFromMin >= checkInMin && availableFromMin < 1440) ||
        (availableToMin > checkInMin && availableToMin <= 1440) ||
        (availableFromMin <= checkInMin && availableToMin >= 1440);

      const overlapAfterMidnight = (availableFromMin >= 0 && availableFromMin < checkOutMin) ||
        (availableToMin > 0 && availableToMin <= checkOutMin) ||
        (availableFromMin <= 0 && availableToMin >= checkOutMin);

      return overlapBeforeMidnight || overlapAfterMidnight;
    } else {
      // Normal case: check-in and check-out are on same day
      return (availableFromMin < checkOutMin && availableToMin > checkInMin);
    }
  }

  function isInAvailableTimeRange(timeMin: number, checkOutMin: number) {
    const midnight = 1440; // 12:00 AM in minutes
    return timeMin >= checkOutMin && timeMin <= midnight;
  }

  // validation function
  const basicInfoValidate = () => {
    var isValid = true;
    var errorTmp = [...error];

    if (primaryLanguage == "English") {

      if (roomNameEN.trim() == "" || roomNameEN.trim() == null || roomNameEN.trim() == undefined) {
        errorTmp[0].roomNameEN = t('Room Name Is Required');
        isValid = false;
      } else if (!hasSpecialCharacters(roomNameEN.trim())) {
        errorTmp[0].roomNameEN = t('Special Characters Is Not Allow');
        isValid = false;
      }
    } else if (primaryLanguage == "Russian") {
      if (roomNameRU.trim() == "" || roomNameRU.trim() == null || roomNameRU.trim() == undefined) {
        errorTmp[0].roomNameRU = t('Room Name Is Required');
        isValid = false;
      } else if (!hasSpecialCharacters(roomNameRU.trim())) {
        errorTmp[0].roomNameRU = t('Special Characters Is Not Allow');
        isValid = false;
      }
    } else if (primaryLanguage == "Uzbek") {
      if (roomNameUZ.trim() == "" || roomNameUZ.trim() == null || roomNameUZ.trim() == undefined) {
        errorTmp[0].roomNameUZ = t('Room Name Is Required');
        isValid = false;
      } else if (!hasSpecialCharacters(roomNameUZ.trim())) {
        errorTmp[0].roomNameUZ = t('Special Characters Is Not Allow');
        isValid = false;
      }
    }
    if (maxPeople == "" || maxPeople == null || maxPeople == undefined) {
      errorTmp[0].maxPeople = t('Max People Is Required');
      isValid = false;
    }
    else if (parseInt(maxPeople) <= 0) {
      errorTmp[0].maxPeople = t('Max People Must Be Greater Than 0');
      isValid = false;
    } else if (parseInt(maxPeople) < parseInt(standardPeople)) {
      errorTmp[0].maxPeople = t('Max People Must Be Greater Than Or Equal To Standard People');
      isValid = false;
    }
    if (standardPeople == "" || standardPeople == null || standardPeople == undefined) {
      errorTmp[0].standardPeople = t('Standard People Is Required');
      isValid = false;
    } else if (!isOnlyNumber(standardPeople)) {
      errorTmp[0].standardPeople = t('Only Number Is Allowed');
      isValid = false;
    }
    setError(errorTmp);
    return isValid;
  }
  const generalInfoValidate = () => {
    var isValid = true;
    var errorTmp = [...error];

    if (primaryLanguage == "English") {
      if (generalInformationEN == "" || generalInformationEN == null || generalInformationEN == undefined) {
        errorTmp[0].generalInformationEN = t('General Information Is Required');
        isValid = false;
      }
    } else if (primaryLanguage == "Russian") {
      if (generalInformationRU == "" || generalInformationRU == null || generalInformationRU == undefined) {
        errorTmp[0].generalInformationRU = t('General Information Is Required');
        isValid = false;
      }
    } else if (primaryLanguage == "Uzbek") {
      if (generalInformationUZ == "" || generalInformationUZ == null || generalInformationUZ == undefined) {
        errorTmp[0].generalInformationUZ = t('General Information Is Required');
        isValid = false;
      }
    }
    setError(errorTmp);
    return isValid;
  }
  const facilityAndServicesValidate = () => {
    var isValid = true;
    var errorTmp = [...error];

    if (amenitiesSelectedOptions.length == 0) {
      errorTmp[0].amenityId = t('Room Amenities Is Required');
      isValid = false;
    }
    if (roomTypeSelectedOptions == "" || roomTypeSelectedOptions == null || roomTypeSelectedOptions == undefined) {
      errorTmp[0].roomTypeId = t('Room Type Is Required');
      isValid = false;
    }
    if (bedTypeSelectedOptions == "" || bedTypeSelectedOptions == null || bedTypeSelectedOptions == undefined) {
      errorTmp[0].bedTypeId = t('Bed Type Is Required');
      isValid = false;
    }
    if (numberOfBathroom == "" || numberOfBathroom == null || numberOfBathroom == undefined) {
      errorTmp[0].numberOfBathroom = t('Number Of Bathroom Is Required');
      isValid = false;
    } else if (!isOnlyNumber(numberOfBathroom)) {
      errorTmp[0].numberOfBathroom = t('Only Number Is Allowed');
      isValid = false;
    } else if (numberOfBathroom <= '0') {
      errorTmp[0].numberOfBathroom = t('Number Of Bathroom Must Be Greater Than 0');
      isValid = false;
    }
    if (bathroomTypeSelectedOptions == "" || bathroomTypeSelectedOptions == null || bathroomTypeSelectedOptions == undefined) {
      errorTmp[0].bathroomTypeId = t('Bathroom Type Is Required');
      isValid = false;
    }

    setError(errorTmp);
    return isValid;
  }
  const pricingAndAvailability = () => {
    var isValid = true;
    var errorTmp = [...error];

    if (availableRoom == "") {
      errorTmp[0].availableRoom = t('Available Room Is Required');
      isValid = false;
    } else if (!isOnlyNumber(availableRoom)) {
      errorTmp[0].availableRoom = t('Only Number Is Allowed');
      isValid = false;
    }
    if (byDay == true) {
      if (baseCharge == "" || baseCharge == null || baseCharge == undefined) {
        errorTmp[0].baseCharge = t('Room Price Is Required');
        isValid = false;
      } else if (!isOnlyNumber(baseCharge)) {
        errorTmp[0].baseCharge = t('Only Number Is Allowed');
        isValid = false;
      }
      if (!isOnlyNumber(extraAdultChargeByDay)) {
        errorTmp[0].extraAdultChargeByDay = t('Only Number Is Allowed');
        isValid = false;
      }
    }
    if (byHours == true) {
      if (baseChargeByHours == "" || baseChargeByHours == null || baseChargeByHours == undefined) {
        errorTmp[0].baseChargeByHours = t('Room Price Is Required');
        isValid = false;
      } else if (!isOnlyNumber(baseChargeByHours)) {
        errorTmp[0].baseChargeByHours = t('Only Number Is Allowed');
        isValid = false;
      }

      const fromMin = timeStrToMinutes(fromAvailableHours);
      const toMin = timeStrToMinutes(toAvailableHours);

      const checkInMin = timeStrToMinutes(checkInTime);
      const checkOutMin = timeStrToMinutes(checkOutTime);
     
      if (!fromAvailableHours) {
        errorTmp[0].fromAvailableHours = t('This Field Is Required');
        isValid = false;
      }

      if (!toAvailableHours) {
        errorTmp[0].toAvailableHours = t('This Field Is Required');
        isValid = false;
      } else if (toMin <= fromMin) {
        errorTmp[0].toAvailableHours = t('Must Be Later Than From Available Time');
        isValid = false;
      }



      // Check for overlap with reserved (check-in/out) range
      if (byDay && byHours && isTimeInReservedRange(fromMin, toMin, checkInMin, checkOutMin)) {
        errorTmp[0].fromAvailableHours = t('Available time cannot overlap with reserved Check-in/Check-out time');
        errorTmp[0].toAvailableHours = t('Available time cannot overlap with reserved Check-in/Check-out time');
        isValid = false;
      }

      if (!isOnlyNumber(extraAdultChargeByHours)) {
        errorTmp[0].extraAdultChargeByHours = t('Only Number Is Allowed')
        isValid = false
      }
    }
    if (byDay == false && byHours == false) {
      errorTmp[0].bookingType = t('Booking Type Is Required');
      isValid = false;
    }
    if (events.length == 0) {
      errorTmp[0].availableDate = t('Please Select Available Date');
      isValid = false;
    }

    setError(errorTmp);
    return isValid;
  }
  const roomPhotosvalidate = () => {

    var isValid = true;
    var errorTmp = [...error];

    if (uploadedImage.length < 2) {
      if (inputImage.length == 0) {
        errorTmp[0].inputImage = t('Room Images Is Required');
        isValid = false;
      } else if (inputImage.length < 2) {
        errorTmp[0].inputImage = t('Minimum 3 Images Is Required');
        isValid = false;
      }
    }

    setError(errorTmp);
    return isValid;
  }

  const handleTabChange = (nextTab: any) => {
    let isValid = true;

    if (isNextTab(nextTab)) {
      switch (tab) {
        case 'BasicInfo':
          isValid = basicInfoValidate();
          break;
        case 'GeneralInfo':
          isValid = generalInfoValidate();
          break;
        case 'FacilityAndServices':
          isValid = facilityAndServicesValidate();
          break;
        case 'PricingAndAvailability':
          isValid = pricingAndAvailability();
          break;
        case 'RoomPhotos':
          isValid = roomPhotosvalidate();
          break;
        default:
          break;
      }
    }
    if (isValid) {
      setTab(nextTab);
    }
  }

  const isNextTab = (nextTab: any) => {
    const tabOrder = ['BasicInfo', 'GeneralInfo', 'FacilityAndServices', 'PricingAndAvailability', 'RoomPhotos'];
    return tabOrder.indexOf(nextTab) > tabOrder.indexOf(tab);
  }

  const nextToGeneralInfo = () => {
    handleTabChange('GeneralInfo');
  }

  const nextToFacilityAndServices = () => {
    handleTabChange('FacilityAndServices');
  }

  const nextToPricingAndAvailability = () => {
    handleTabChange('PricingAndAvailability');
  }

  const nextToRoomPhotos = () => {
    handleTabChange('RoomPhotos');
  }

  // ------------------- for schedule calander -------------------------
  const localizer = momentLocalizer(moment);

  interface CustomEvent {
    start: Date;
    end: Date;
    title: string;
    type: 'available' | 'unavailable';
  }
  const [events, setEvents] = useState<CustomEvent[]>([]);
  const [unAvailableEvents, setUnAvailableEvents] = useState<CustomEvent[]>([]);

  // Function to generate default events from today to one year ahead, ensuring UTC time zone
  const generateDefaultEvents = (unavailableEvents: CustomEvent[]) => {
    const defaultEvents: CustomEvent[] = [];

    // Force UTC start and end
    const startDate = moment.utc().startOf('day'); // Start at UTC midnight
    const endDate = moment.utc().add(2, 'year').endOf('day'); // End at UTC midnight of 2 years later

    // Iterate through days, setting each event to UTC midnight
    for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(1, 'day')) {
      const eventDate = date.clone().toDate(); // Convert to JS Date in UTC

      // Check for existing unavailable events and create the appropriate event
      if (unavailableEvents.some(event => moment.utc(event.start).isSame(date, 'day'))) {
        defaultEvents.push({
          start: eventDate,
          end: eventDate,
          title: 'Unavailable',
          type: 'unavailable'
        });
      } else {
        defaultEvents.push({
          start: eventDate,
          end: eventDate,
          title: 'Available',
          type: 'available'
        });
      }
    }
    return defaultEvents;
  };

  // Use effect to synchronize unavailable events with the events state
  useEffect(() => {
    const updatedEvents = generateDefaultEvents(unAvailableEvents);
    setEvents(updatedEvents);
  }, [unAvailableEvents]);

  const handleSelectSlot = (slotInfo: SlotInfo) => {
    if (!availableTypeSelectedOptions) {
      toasterrormsg(t('Please Select Availability Type (available/unavailable).'));
      return;
    }

    const selectedDates: Date[] = [];

    // Convert both start and end to UTC with 12 AM time
    const startOfRange = moment.utc(slotInfo.start).startOf('day').add(1, 'days'); // Start of day in UTC
    const endOfRange = moment.utc(slotInfo.end).startOf('day'); // End of day in UTC

    // Loop through dates and select them in UTC
    for (let date = startOfRange.clone(); date.isSameOrBefore(endOfRange); date.add(1, 'day')) {
      selectedDates.push(date.toDate());
    }

    updateEvents(selectedDates);
  };

  const updateEvents = (selectedDates: Date[]) => {
    if (!availableTypeSelectedOptions) {
      toasterrormsg(t("Please Select Availability Types"));
      return;
    }

    const newEvents: CustomEvent[] = [];
    const eventsToRemove: CustomEvent[] = [];

    selectedDates.forEach(selectedDate => {
      const selectedMoment = moment.utc(selectedDate).startOf('day'); // Set to UTC midnight
      const existingEventIndex = events.findIndex(event => moment.utc(event.start).isSame(selectedMoment, 'day'));

      if (existingEventIndex !== -1) {
        eventsToRemove.push(events[existingEventIndex]);
      }

      const newEvent: CustomEvent = {
        start: selectedMoment.toDate(),
        end: selectedMoment.toDate(),
        title: availableTypeSelectedOptions.value!.charAt(0).toUpperCase() + availableTypeSelectedOptions.value!.slice(1),
        type: availableTypeSelectedOptions.value!
      };
      newEvents.push(newEvent);
    });

    const updatedEvents = events.filter(existingEvent =>
      !eventsToRemove.some(removeEvent => moment.utc(existingEvent.start).isSame(moment.utc(removeEvent.start), 'day'))
    );

    setEvents([...updatedEvents, ...newEvents]);

    // Update unavailable events
    if (availableTypeSelectedOptions.value === 'unavailable') {
      const newUnavailableEvents = newEvents.filter(event => event.type === 'unavailable');
      setUnAvailableEvents([...unAvailableEvents, ...newUnavailableEvents]);
    } else {
      const remainingUnavailableEvents = unAvailableEvents.filter(event =>
        !newEvents.some(ne => moment.utc(ne.start).isSame(moment.utc(event.start), 'day'))
      );
      setUnAvailableEvents(remainingUnavailableEvents);
    }
  };

  // Apply available dates with UTC time zone
  const ApplyAvailableDates = () => {
    if (!startAvailableDate || !endAvailableDate) {
      toasterrormsg(t('Please Select Both Start And End Dates.'));
      return;
    }

    const startDate = moment.utc(startAvailableDate).startOf('day'); // Convert start date to UTC midnight
    const endDate = moment.utc(endAvailableDate).startOf('day'); // Convert end date to UTC midnight
    const today = moment.utc().startOf('day'); // Current date in UTC

    if (startDate.isBefore(today) || endDate.isBefore(today)) {
      toasterrormsg(t('Please Select Only Current Or Future Dates.'));
      return;
    }

    const selectedDates: Date[] = [];

    // Loop through and convert each date to UTC
    for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(1, 'day')) {
      selectedDates.push(date.toDate());
    }

    updateEvents(selectedDates);
  };

  // Clear available dates with UTC time zone
  const clearAvailableDates = () => {
    if (!startAvailableDate || !endAvailableDate) {
      toasterrormsg(t('Please Select Both Start And End Dates.'));
      return;
    }

    const startDate = moment.utc(startAvailableDate).startOf('day'); // Convert start date to UTC midnight
    const endDate = moment.utc(endAvailableDate).startOf('day'); // Convert end date to UTC midnight
    const today = moment.utc().startOf('day'); // Current date in UTC

    if (startDate.isBefore(today) || endDate.isBefore(today)) {
      toasterrormsg(t('Please Select Only Current Or Future Dates.'));
      return;
    }

    const selectedDates: Date[] = [];

    // Loop through and convert each date to UTC
    for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(1, 'day')) {
      selectedDates.push(date.toDate());
    }

    const updatedEvents: CustomEvent[] = events.map(event => {
      const eventDate = moment.utc(event.start).startOf('day'); // Convert event date to UTC
      if (event.type === 'unavailable' && selectedDates.some(date => moment.utc(date).isSame(eventDate, 'day'))) {
        return {
          ...event,
          title: 'Available',
          type: 'available'
        };
      }
      return event;
    });

    setEvents(updatedEvents);

    // Remove the corresponding events from unAvailableEvents
    const updatedUnavailableEvents = unAvailableEvents.filter(event => {
      const eventDate = moment.utc(event.start).startOf('day'); // Convert event date to UTC
      return !selectedDates.some(date => moment.utc(date).isSame(eventDate, 'day'));
    });

    setUnAvailableEvents(updatedUnavailableEvents);
  };

  const handleRemoveEvent = (event: CustomEvent) => {
    const updatedEvents = events.filter(existingEvent =>
      !(
        existingEvent.start === event.start &&
        existingEvent.end === event.end &&
        existingEvent.title === event.title &&
        existingEvent.type === event.type
      )
    );
    setEvents(updatedEvents);

    // Remove from unavailable events if applicable
    if (event.type === 'unavailable') {
      const updatedUnavailableEvents = unAvailableEvents.filter(unavailableEvent =>
        !(
          unavailableEvent.start === event.start &&
          unavailableEvent.end === event.end &&
          unavailableEvent.title === event.title &&
          unavailableEvent.type === event.type
        )
      );
      setUnAvailableEvents(updatedUnavailableEvents);
    }
  };

  const eventStyleGetter: CalendarProps<CustomEvent>['eventPropGetter'] = (event, start, end, isSelected) => {
    const backgroundColor = event.type === 'available' ? 'green' : 'red';
    const style = {
      backgroundColor,
      borderRadius: '0px',
      opacity: 0.8,
      color: 'white',
      border: '0px',
      display: 'block'
    };
    return {
      style
    };
  };
  // ------------------------------------- apis call ------------------------------------
  // hotel Details api call
  const hotelDetailsApiCall = async () => {

    var param: any = {
      hotelId: editHotelId
    }
    var response: any = await fetchData("vendor/public/hotelDetailsV2", param)

    if (response.status == "200") {

      var roomList = response.data[0]['roomList'];
      setCheckInTime(response.data[0].checkInTime)
      setCheckOutTime(response.data[0].checkOutTime)
      setHotelDetails(roomList);
      setHotelDetail(response.data);
      setPrimLanguage(response.data[0]['primaryLanguage'])
      var tmp: any = roomList.slice(offset, offset + limit);
      setDisplayRoomList(tmp)
      var totpag = (Math.ceil(roomList.length / limit))
      setTotalPage(totpag)
      if (totpag == 1) {
        var mod = roomList.length % limit
        if (mod > 0) {
          setTo(mod)
        }
        else {
          setTo(tmp.length)
        }
      }
      else {
        var mod = roomList.length % limit
        if (mod > 0) {
          setTo(page * limit + mod)
        }
        else {
          setTo(page * limit)
        }
      }
      var genpag = generatePageNumbers(page, totpag, 6)
      setPageNumberList(genpag)

      if (editRoomId != "") {

        var room = roomList.find((value: any) => value['roomId'] === editRoomId);

        setRoomNameEN(room['en_roomName'])
        setRoomNameRU(room['ru_roomName'])
        setRoomNameUZ(room['uz_roomName'])
        setGeneralInformationEN(room['en_generalInformation'])
        setGeneralInformationRU(room['ru_generalInformation'])
        setGeneralInformationUZ(room['uz_generalInformation'])
        setMaxPeople(room['maxPeople'])

        var amenities: any = []
        room['facilities'].map((val: any) => {
          amenities.push({ value: val.amenityId, label: getTranslatedValue(lang, val, '_name') })
        })
        setAmenitiesSelectedOptions(amenities)
        setOldAmenitiesSelectedOptions(amenities)

        var roomType = roomTypeList.filter((value: any) => value.value == room.roomType);
        setRoomTypeSelectedOptions(roomType[0])
        setOldRoomTypeSelectedOptions(roomType[0] || null)

        var bedType = bedTypeList.filter((value: any) => value.value == room.bedType)
        setBedTypeSelectedOptions(bedType[0])
        setOldBedTypeSelectedOptions(bedType[0] || null)
        setNumberOfBathroom(room['numberOfBathroom'])
        var bathroomType = bathroomTypeList.filter((value: any) => value.value == room.bathroomtypeId)
        setBathroomTypeSelectedOptions(bathroomType[0])
        setOldBathroomTypeSelectedOptions(bathroomType[0] || null)
        setByDay(room['bookByDay'] == '1' ? true : false)
        setByHours(room['bookByTime'] == '1' ? true : false)
        setUnAvailableEvents(room['availableDate'] ? room['availableDate'] : [])
        setBaseCharge(room['baseCharge'])
        setBaseChargeByHours(room['baseChargeByHours'])
        setFromAvailableHours(room['fromAvailableHours'])
        setToAvailableHours(room['toAvailableHours'])
        setExtraAdultChargeByDay(room['extraAdultCharge'])
        setExtraAdultChargeByHours(room['extraAdultChargeByHours'])
        setAvailableRoom(room['availableRoom'] + '')
        setStandardPeople(room['standardPeople'])
        setUploadedImage(room['images'])

        if (room['specialPriceDetail'].length > 0) {
          setSpecialPrice(room['specialPriceDetail'])
        }
      }
    }
    else {
      toasterrormsg(response.message)
    }
  }
  // amenity list api call
  const amenityListAPIcall = async () => {

    var param = {
      'categoryId': '1'
    }
    var res = await fetchData("vendor/public/amenityList", param)

    if (res.status == "200") {
      var opt: any = []
      
      res.data.map((val: any) => {
        opt.push({ value: val.amenityId, label: getTranslatedValue(lang, val, '_name') })
      })
      setAmenitiesList(opt)

    }
    else {
      toasterrormsg(res.message)
    }
  }
  // hotel Room Type list api call
  const hotelRoomTypeListAPIcall = async () => {

    var res = await fetchData("vendor/public/hotelRoomTypeList", [])

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.roomtypeId, label: getTranslatedValue(lang, val, '_name') })
      })
      setRoomTypeList(opt)

    }
    else {
      toasterrormsg(res.message)
    }
  }
  // bed type list api call
  const hotelBedTypeListAPIcall = async () => {

    var res = await fetchData("vendor/public/hotelBedTypeList", [])

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.bedtypeId, label:getTranslatedValue(lang, val, '_name') })
      })
      setBedTypeList(opt)

    }
    else {
      toasterrormsg(res.message)
    }
  }
  const hotelBathroomTypeListAPIcall = async () => {

    var res = await fetchData("vendor/public/hotelBathroomTypeList", [])

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.bathroomtypeId, label: getTranslatedValue(lang, val, '_name') })
      })
      setBathroomTypeList(opt)
    }
    else {
      toasterrormsg(res.message)
    }
  }

  // add room api call
  const addRoomApi = async () => {
    if (roomPhotosvalidate()) {

      setDisable(true)
      setLoading(true)
      let param = new FormData()
      param.append('hotelId', editHotelId)
      param.append('adminId', adminId)
      param.append('en_roomName', roomNameEN)
      param.append('ru_roomName', roomNameRU)
      param.append('uz_roomName', roomNameUZ)
      param.append('standardPeople', standardPeople)
      param.append('maxPeople', maxPeople)
      param.append('en_generalInformation', generalInformationEN)
      param.append('ru_generalInformation', generalInformationRU)
      param.append('uz_generalInformation', generalInformationUZ)
      param.append('amenityId', amenityId)
      param.append('roomtypeId', roomTypeSelectedOptions.value)
      param.append('bedtypeId', bedTypeSelectedOptions.value)
      param.append('numberOfBathroom', numberOfBathroom)
      param.append('bathroomtypeId', bathroomTypeSelectedOptions.value)
      param.append('isSmokingAllowed', isSmokingAllowed)
      param.append('availableRoom', availableRoom)
      param.append('specialPrice', JSON.stringify(specialPrice))
      if (byDay == true) {
        param.append('baseCharge', baseCharge)
        param.append('extraAdultCharge', extraAdultChargeByDay)
      }
      if (byHours == true) {
        param.append('baseChargeByHours', baseChargeByHours)
        param.append('fromAvailableHours', moment(fromAvailableHours, 'HH:mm').format('HH:mm:ss'))
        param.append('toAvailableHours', moment(toAvailableHours, 'HH:mm').format('HH:mm:ss'))
        param.append('extraAdultChargeByHours', extraAdultChargeByHours)
      }
      param.append('byDay', byDay ? '1' : '0')
      param.append('byHours', byHours ? '1' : '0')
      param.append('availableDate', JSON.stringify(unAvailableEvents))

      param.append('labels', buildDropdownAudit({
        roomType: { old: oldRoomTypeSelectedOptions, new: roomTypeSelectedOptions },
        bedType: { old: oldBedTypeSelectedOptions, new: bedTypeSelectedOptions },
        bathroomType: { old: oldBathroomTypeSelectedOptions, new: bathroomTypeSelectedOptions },
        amenities: { old: oldAmenitiesSelectedOptions, new: amenitiesSelectedOptions, multi: true },
      }))

      if (inputImage.length != 0) {
        inputImage.forEach((file: any) => {
          param.append('image', file);
        });
      }

      var res = await fetchFormData("vendor/public/addRoomV2", param)

      if (res.status == "200") {
        toastsuccessmsg(t("Room Added Successfully!"))
        hotelDetailsApiCall()
        handleClose()
        cleanStates()
        setDisable(false)
        setLoading(false);

      }
      else {
        setLoading(false);
        toasterrormsg(res.message)
        setDisable(false)

      }
    }
  }
  //   delete hotel api call
  const confirmdelete = (roomId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('No'),
    }).then(async (result) => {
      if (result.isConfirmed) {

        var param = {
          'roomId': roomId,
                adminId:adminId
        }
        var res = await fetchData("vendor/public/deleteRoom", param)

        if (res.status == "200") {
          hotelDetailsApiCall();
        }
        else {
          toasterrormsg(res.message)
        }
      }
    });
  }
  const editModalOpen = (roomId: any) => {
    setEditRoomId(roomId);
    handleShow()
  }
  useEffect(() => {
    hotelDetailsApiCall();
  }, [editRoomId])
  // edit room api call
  const editRoomApi = async () => {
    if (roomPhotosvalidate()) {
      setDisable(true)
      setLoading(true)
      let param = new FormData()
      param.append('hotelId', editHotelId)
      param.append('roomId', editRoomId)
      param.append('adminId', adminId)
      param.append('en_roomName', roomNameEN)
      param.append('ru_roomName', roomNameRU)
      param.append('uz_roomName', roomNameUZ)
      param.append('standardPeople', standardPeople)
      param.append('maxPeople', maxPeople)
      param.append('en_generalInformation', generalInformationEN)
      param.append('ru_generalInformation', generalInformationRU)
      param.append('uz_generalInformation', generalInformationUZ)
      param.append('amenityId', amenityId)
      param.append('roomtypeId', roomTypeSelectedOptions.value)
      param.append('bedtypeId', bedTypeSelectedOptions.value)
      param.append('numberOfBathroom', numberOfBathroom)
      param.append('bathroomtypeId', bathroomTypeSelectedOptions.value)
      param.append('isSmokingAllowed', isSmokingAllowed)
      param.append('availableRoom', availableRoom)
      param.append('specialPrice', JSON.stringify(specialPrice))
      if (byDay == true) {
        param.append('baseCharge', baseCharge)
        param.append('extraAdultCharge', extraAdultChargeByDay)
      }
      if (byHours == true) {
        param.append('baseChargeByHours', baseChargeByHours)
        param.append('fromAvailableHours', moment(fromAvailableHours, 'HH:mm').format('HH:mm:ss'))
        param.append('toAvailableHours', moment(toAvailableHours, 'HH:mm').format('HH:mm:ss'))
        param.append('extraAdultChargeByHours', extraAdultChargeByHours)
      }
      param.append('byDay', byDay ? '1' : '0')
      param.append('byHours', byHours ? '1' : '0')
      param.append('availableDate', JSON.stringify(unAvailableEvents))

      param.append('labels', buildDropdownAudit({
        roomType: { old: oldRoomTypeSelectedOptions, new: roomTypeSelectedOptions },
        bedType: { old: oldBedTypeSelectedOptions, new: bedTypeSelectedOptions },
        bathroomType: { old: oldBathroomTypeSelectedOptions, new: bathroomTypeSelectedOptions },
        amenities: { old: oldAmenitiesSelectedOptions, new: amenitiesSelectedOptions, multi: true },
      }))

      if (inputImage.length != 0) {
        inputImage.forEach((file: any) => {
          param.append('image', file);
        });
      }
      var res = await fetchFormData("vendor/public/editRoomV2", param)

      if (res.status == "200") {
        toastsuccessmsg(t("Room Updated Successfully!"))
        hotelDetailsApiCall()
        handleClose()
        cleanStates()
        setDisable(false)
        setLoading(false)
      }
      else {
        setLoading(false);
        toasterrormsg(res.message)
        setDisable(false)
      }
    }
    setDisable(false)

  }

  useEffect(() => {
    amenityListAPIcall()
    hotelRoomTypeListAPIcall()
    hotelBedTypeListAPIcall()
    hotelBathroomTypeListAPIcall()
  }, [])

  const handleTimeChange = (date: any) => {
    if (date && date.length > 0) {
      const selectedTime = moment(date[0]); // Get the first element if date is an array
      if (selectedTime.isValid()) {
        let roundedTime = selectedTime.clone().second(0); // Reset seconds to 0

        if (selectedTime.minute() > 0) {
          // If minutes are greater than 0, always round up to the next hour
          roundedTime = roundedTime.add(1, 'hour').minute(0);
        } else {
          // If minutes are exactly 0, keep the hour as is
          roundedTime = roundedTime.minute(0);
        }

        return roundedTime.format('HH:mm'); // Return the rounded time
      } else {
        console.error("Invalid date selected");
      }
    }
    return '00:00'; // Default value if no valid date is selected
  };

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    const parsedTime = moment(value, 'HH:mm:ss');
    // Format the time as HH:mm:ss
    var formattedValue = parsedTime.isValid() ? parsedTime.format('HH:mm:ss') : '';

    // Check if the value is "00:00:00" and change it to "23:59:59"
    if (formattedValue == '00:00:00' && name === 'toAvailableHours') {
      formattedValue = '23:59:59';
    }
    return formattedValue;
  };
  const cleanStates = () => {
    setLoading(false);
    setRoomNameEN("");
    setRoomNameRU("");
    setRoomNameUZ("");
    setGeneralInformationEN("");
    setGeneralInformationRU("");
    setGeneralInformationUZ("");
    setMaxPeople("");
    setAmenitiesSelectedOptions([]);
    setRoomTypeSelectedOptions(undefined);
    setBedTypeSelectedOptions(undefined);
    setNumberOfBathroom("")
    setBathroomTypeSelectedOptions(undefined);
    setIsSmokingAllowed("No");
    setByDay(true)
    setByHours(true)
    setAvailableTypeSelectedOptions(undefined);
    setEvents([]);
    setUnAvailableEvents([]);
    setTab("BasicInfo");
    setBaseCharge("");
    setBaseChargeByHours("");
    setExtraAdultChargeByDay("");
    setAvailableRoom("");
    setStandardPeople("");
    setInputImage([]);
    setUploadedImage([]);
    resetForm();
    setPriceTab("RegularPrice");
    setSpecialPrice([]);
    clearValidationError("en_title");
    clearValidationError("ru_title");
    clearValidationError("uz_title");
    clearValidationError("fromDate");
    clearValidationError("toDate");
    clearValidationError("hourlyMondayPrice");
    clearValidationError("hourlyTuesdayPrice");
    clearValidationError("hourlyWednedayPrice");
    clearValidationError("hourlyThurdayPrice");
    clearValidationError("hourlyFridayPrice");
    clearValidationError("hourlySaturdayPrice");
    clearValidationError("hourlySundayPrice");
    removeError("roomNameEN");
    removeError("roomNameRU");
    removeError("roomNameUZ");
    removeError("generalInformationEN");
    removeError("generalInformationRU");
    removeError("generalInformationUZ");
    removeError("standardPeople");
    removeError("maxPeople");
    removeError("amenityId");
    removeError("roomTypeId");
    removeError("bedTypeId");
    removeError("numberOfBathroom");
    removeError("bathroomTypeId");
    removeError("availableRoom");
    removeError("baseCharge");
    removeError("bookingType")
    removeError("fromAvailableHours");
    removeError("toAvailableHours");
    removeError("minimumHours");
    removeError("availableDate");
    removeError("inputImage");
  }

  useEffect(() => {
    const modal = document.querySelector('.modal');
    if (modal) {
      modal.removeAttribute('tabindex');
    }
  }, [show]);
  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('View Rooms')}</PageTitle>
      <ToastContainer />
      <AddHotelHeader hotelId={editHotelId} />
      <div className="d-flex flex-column">
        {/* <!--begin::General options--> */}
        <div className="card card-flush py-4">
          {/* <!--begin::Card header--> */}
          <div className="card-header d-flex">
            {/* <!--begin::Card title--> */}
            <div className="card-title">
              <h2>{t('Room Details')}</h2>
            </div>
            {/* <!--end::Card title--> */}
            <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
              {
                hotelDetail.length != 0 ? (
                  <>
                    {
                      hotelDetail.map((completedSteps: any, index: any) => {
                        var percentage = 0;
                        if (completedSteps['completedSteps']['basicInfo']) {
                          percentage = 10;
                        }
                        if (completedSteps['completedSteps']['location']) {
                          percentage = 20;
                        }
                        if (completedSteps['completedSteps']['propertyDetail']) {
                          percentage = 40;
                        }
                        if (completedSteps['completedSteps']['roomAndSpace']) {
                          percentage = 50;
                        }
                        if (completedSteps['completedSteps']['photos']) {
                          percentage = 60;
                        }
                        if (completedSteps['completedSteps']['facilitiesAndServices']) {
                          percentage = 70;
                        }
                        if (completedSteps['completedSteps']['policies']) {
                          percentage = 90;
                        }
                        if (completedSteps['completedSteps']['financeAndLegal']) {
                          percentage = 100;
                        }
                        return (
                          <React.Fragment key={index}>
                            <div className='d-flex justify-content-between w-100 mt-auto'>
                              <span className='fw-bold fs-6'>{t('Completion')}</span>
                              <span className='fw-bolder fs-6'>{percentage}%</span>
                            </div>
                            <div className='h-5px mx-3 w-100 bg-light mb-3'>
                              <div
                                className='bg-success rounded h-5px'
                                role='progressbar'
                                style={{ width: `${percentage}%` }}
                              ></div>
                            </div>
                          </React.Fragment>
                        )
                      })
                    }
                  </>
                ) : (
                  <>
                    <div className='d-flex justify-content-between w-100 mt-auto'>
                      <span className='fw-bold fs-6'>{t('Completion')}</span>
                      <span className='fw-bolder fs-6'>0%</span>
                    </div>
                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                      <div
                        className='bg-success rounded h-5px'
                        role='progressbar'
                        style={{ width: '0%' }}
                      ></div>
                    </div>
                  </>
                )
              }
            </div>
          </div>
          {/* <!--end::Card header--> */}
          <div className="d-flex justify-content-end mx-10 mt-3">
            <button
              className='btn text-white cursor-pointer btn-primary'
              id='kt_toolbar_primary_button'
              style={{ color: 'rgb(24, 28, 50)' }}
              onClick={handleShow}
            >
              + {t('Add Rooms')}
            </button>
          </div>
        </div>
        {/* <!--end::Pricing--> */}
      </div>
      {/* begin::Row */}
      <div className='row g-5 g-xl-8 mt-3'>
        {
          displayRoomList.map((room: any, index: any) => {
            var description = "";
            var roomName = "";
            if (primLanguage == "English") {
              description = room['en_description'];
              roomName = room['en_roomName'];
            } else if (primLanguage == "Russian") {
              description = room['ru_description'];
              roomName = room['ru_roomName'];
            } else if (primLanguage == "Uzbek") {
              description = room['uz_description'];
              roomName = room['uz_roomName'];
            }
            return (
              <div className='col-xl-4' key={index}>
                <MixedWidget17
                  className='card-xl-stretch mb-5 mb-xl-8'
                  color='success'
                  roomId={room['roomId']}
                  hotelId={room['hotelId']}
                  deleteRoom={confirmdelete}
                  editModalOpen={editModalOpen}
                  roomName={roomName}
                  image={room['images'].length != 0 ? room['images'][0].thumbPath : ''}
                  description={description}
                  maxPeople={room['maxPeople']}
                  progress='100%'
                  showDelete={menuIdDelete}
                  showEdit={menuIdEdit}
                  menuId={menuId}
                />
              </div>
            )
          })
        }
      </div>
      {
        hotelDetails.length != 0 ? (
          <>
            <div className='d-flex flex-stack flex-wrap pt-10'>
              <div className='fs-6 fw-bold text-gray-700'>Showing {from} to {to} of {hotelDetails.length} entries</div>

              <ul className='pagination'>

                <li className={`page-item previous ${page > 1 ? "" : "disabled"}`}>
                  <span className={`page-link ${page > 1 ? "cursor-pointer" : "disabled"}`} onClick={() => onPageChange(page - 1)}>
                    <i className='previous'></i>
                  </span>
                </li>
                {pageNumbersList.map((item: any, index: any) => {
                  return (
                    <li className={`page-item cursor-pointer ${page == item ? "active" : ""}`} key={index}>
                      <span className='page-link' onClick={() => onPageChange(item)}>
                        {item}
                      </span>
                    </li>
                  )
                })}

                <li className={`page-item next ${page + 1 <= totalPage ? "" : "disabled"}`}>
                  <span className={`page-link ${page + 1 <= totalPage ? "cursor-pointer" : "disabled"}`} onClick={() => page + 1 <= totalPage ? onPageChange(page + 1) : ""}>
                    <i className='next'></i>
                  </span>
                </li>
              </ul>
            </div>
            <div className="row my-10">
              <div className='col-lg-12 text-end'>
                <Link
                  to={getEncryptedRoute('../addhotelphotos/', { menuId: menuId })}
                  state={{ hotelId: editHotelId }}
                  className='btn btn-primary'
                >
                  {t('Next')}
                </Link>
              </div>
            </div>
          </>
        ) : ('')
      }
      {/* end::Row */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal fade show" id="kt_modal_upload" tabIndex={-1} style={{ display: "block" }} aria-modal="true" role="dialog">
          {/* <!--begin::Modal dialog--> */}
          <div className="modal-dialog modal-dialog-centered mw-950px">
            {/* <!--begin::Modal content--> */}
            <div className="modal-content">
              {/* <!--begin::Form--> */}
              <div className="form" id="kt_modal_upload_form">
                {/* <!--begin::Modal header--> */}
                <div className="modal-header d-flex justify-content-between">
                  {/* <!--begin::Modal title--> */}
                  <h2 className="fw-bold"> {editRoomId != "" ? t('Edit Rooms') : t('Add Rooms')}</h2>
                  {/* <!--end::Modal title--> */}
                  {/* <!--begin::Close--> */}
                  <div className="btn btn-icon btn-sm btn-active-icon-primary" onClick={handleClose}>
                    <i className="ki-duotone ki-cross fs-1"><span className="path1"></span><span className="path2"></span></i>
                  </div>
                  {/* <!--end::Close--> */}
                </div>
                <div className='card card-custom'>
                  <div className='card-header card-header-stretch overflow-auto'>
                    <ul
                      className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                      role='tablist'
                    >
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer`, { active: tab === 'BasicInfo' })}
                          onClick={() => setTab('BasicInfo')}
                          role='tab'
                        >
                          {t('Basic Info')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer`, { active: tab === 'GeneralInfo' })}
                          onClick={nextToGeneralInfo}
                          role='tab'
                        >
                          {t('General Information')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer`, { active: tab === 'FacilityAndServices' })}
                          onClick={nextToFacilityAndServices}
                          role='tab'
                        >
                          {t('Facility & Services')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer`, { active: tab === 'PricingAndAvailability' })}
                          onClick={nextToPricingAndAvailability}
                          role='tab'
                        >
                          {t('Pricing & Availability')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer`, { active: tab === 'RoomPhotos' })}
                          onClick={nextToRoomPhotos}
                          role='tab'
                        >
                          {t('Room Photos')}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <!--end::Modal header--> */}
                {/* <!--begin::Modal body--> */}
                <div className="modal-body p-5 px-lg-17">
                  {/* <!--begin::Input group--> */}
                  <div className="form-group">
                    {/* <!--begin::Dropzone--> */}
                    <div className="dropzone dropzone-queue mb-2" id="kt_modal_upload_dropzone">
                      {/* <!--begin::Controls--> */}
                      <div className="dropzone-panel mb-4">
                        <div className='tab-content pt-3'>
                          <div className={clsx('tab-pane', { active: tab === 'BasicInfo' })}>
                            {
                              primaryLanguage == "English" && (
                                <>
                                  <div className="row">
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="required fs-5 form-label">{t('Room Name (English)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="roomNameEN" className="form-control mb-2" placeholder={t("Room Name")} value={roomNameEN} onChange={(e) => { setRoomNameEN(e.target.value); removeError("roomNameEN"); }} />
                                      <div className='text-danger fw-bold'>{error[0].roomNameEN}</div>
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="fs-5 form-label">{t('Room Name (Russian)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="roomNameRU" className="form-control mb-2" placeholder={t("Room Name")} value={roomNameRU} onChange={(e) => { setRoomNameRU(e.target.value) }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="fs-5 form-label">{t('Room Name (Uzbek)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="roomNameUZ" className="form-control mb-2" placeholder={t("Room Name")} value={roomNameUZ} onChange={(e) => { setRoomNameUZ(e.target.value) }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                  </div>
                                </>
                              )
                            }
                            {
                              primaryLanguage == "Russian" && (
                                <>
                                  <div className="row">
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="required fs-5 form-label">{t('Room Name (Russian)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="roomNameRU" className="form-control mb-2" placeholder={t("Room Name")} value={roomNameRU} onChange={(e) => { setRoomNameRU(e.target.value); removeError("roomNameRU"); }} />
                                      <div className='text-danger fw-bold'>{error[0].roomNameRU}</div>
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className=" fs-5 form-label">{t('Room Name (English)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="roomNameEN" className="form-control mb-2" placeholder={t("Room Name")} value={roomNameEN} onChange={(e) => { setRoomNameEN(e.target.value) }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="fs-5 form-label">{t('Room Name (Uzbek)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="roomNameUZ" className="form-control mb-2" placeholder={t("Room Name")} value={roomNameUZ} onChange={(e) => { setRoomNameUZ(e.target.value) }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                  </div>
                                </>
                              )
                            }
                            {
                              primaryLanguage == "Uzbek" && (
                                <>
                                  <div className="row">
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="required fs-5 form-label">{t('Room Name (Uzbek)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="roomNameUZ" className="form-control mb-2" placeholder={t("Room Name")} value={roomNameUZ} onChange={(e) => { setRoomNameUZ(e.target.value); removeError("roomNameUZ"); }} />
                                      <div className='text-danger fw-bold'>{error[0].roomNameUZ}</div>
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className=" fs-5 form-label">{t('Room Name (Russian)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="roomNameRU" className="form-control mb-2" placeholder={t("Room Name")} value={roomNameRU} onChange={(e) => { setRoomNameRU(e.target.value) }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className=" fs-5 form-label">{t('Room Name (English)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="roomNameEN" className="form-control mb-2" placeholder={t("Room Name")} value={roomNameEN} onChange={(e) => { setRoomNameEN(e.target.value) }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                  </div>
                                </>
                              )
                            }
                            <div className="row">
                              <div className="col-lg-4 my-3">
                                {/* <!--begin::Label--> */}
                                <label className="required fs-5 form-label">{t('Standard People')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input type="text" name="standardPeople" className="form-control mb-2" placeholder={t("Standard People")} value={standardPeople} onChange={(e) => { setStandardPeople(e.target.value); removeError("standardPeople"); }} />
                                <div className='text-danger fw-bold'>{error[0].standardPeople}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className="col-lg-4 my-3">
                                {/* <!--begin::Label--> */}
                                <label className="required fs-5 form-label">{t('Max People')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input type="text" name="maxPeople" className="form-control mb-2" placeholder={t("Max People")} value={maxPeople} onChange={(e) => { setMaxPeople(e.target.value); removeError("maxPeople"); }} />
                                <div className='text-danger fw-bold'>{error[0].maxPeople}</div>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button type='button' className='btn btn-light-primary me-4' onClick={handleClose}>{t('Cancel')}</button>
                                  <button type='button' disabled={disable} className='btn btn-primary me-4' onClick={nextToGeneralInfo}>
                                    <span className='indicator-label'>{t('Next')}</span>
                                    {loading && (
                                      <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                  </button>
                                  {' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content pt-3'>
                          <div className={clsx('tab-pane', { active: tab === 'GeneralInfo' })}>
                            {
                              primaryLanguage == "English" && (
                                <>
                                  <div className="row">
                                    <div className="col-lg-12 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="required fs-5 form-label">{t('General Information (English)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <JoditEditor
                                        ref={editorRefEN}
                                        config={editorConfig}
                                        value={generalInformationEN}
                                        onBlur={newContent => { setGeneralInformationEN(newContent); removeError("generalInformationEN"); }} />
                                      <div className='text-danger fw-bold'>{error[0].generalInformationEN}</div>
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-12 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="fs-5 form-label">{t('General Information (Russian)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <JoditEditor
                                        ref={editorRefRU}
                                        config={editorConfig}
                                        value={generalInformationRU}
                                        onBlur={newContent => { setGeneralInformationRU(newContent); }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-12 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="fs-5 form-label">{t('General Information (Uzbek)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <JoditEditor
                                        ref={editorRefUZ}
                                        config={editorConfig}
                                        value={generalInformationUZ}
                                        onBlur={newContent => { setGeneralInformationUZ(newContent); }} />
                                    </div>
                                  </div>
                                </>
                              )
                            }
                            {
                              primaryLanguage == "Russian" && (
                                <>
                                  <div className="row">
                                    <div className="col-lg-12 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="required fs-5 form-label">{t('General Information (Russian)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <JoditEditor
                                        ref={editorRefRU}
                                        config={editorConfig}
                                        value={generalInformationRU}
                                        onBlur={newContent => { setGeneralInformationRU(newContent); removeError("generalInformationRU"); }} />
                                      <div className='text-danger fw-bold'>{error[0].generalInformationRU}</div>
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-12 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className=" fs-5 form-label">{t('General Information (English)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <JoditEditor
                                        ref={editorRefEN}
                                        config={editorConfig}
                                        value={generalInformationEN}
                                        onBlur={newContent => { setGeneralInformationEN(newContent); }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-12 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="fs-5 form-label">{t('General Information (Uzbek)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <JoditEditor
                                        ref={editorRefUZ}
                                        config={editorConfig}
                                        value={generalInformationUZ}
                                        onBlur={newContent => { setGeneralInformationUZ(newContent); }} />
                                    </div>
                                  </div>
                                </>
                              )
                            }
                            {
                              primaryLanguage == "Uzbek" && (
                                <>
                                  <div className="row">
                                    <div className="col-lg-12 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="required fs-5 form-label">{t('General Information (Uzbek)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <JoditEditor
                                        ref={editorRefUZ}
                                        config={editorConfig}
                                        value={generalInformationUZ}
                                        onBlur={newContent => { setGeneralInformationUZ(newContent); removeError("generalInformationUZ"); }} />
                                      <div className='text-danger fw-bold'>{error[0].generalInformationUZ}</div>
                                    </div>
                                    <div className="col-lg-12 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className=" fs-5 form-label">{t('General Information (Russian)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <JoditEditor
                                        ref={editorRefRU}
                                        config={editorConfig}
                                        value={generalInformationRU}
                                        onBlur={newContent => { setGeneralInformationRU(newContent); }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-12 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className=" fs-5 form-label">{t('General Information (English)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <JoditEditor
                                        ref={editorRefEN}
                                        config={editorConfig}
                                        value={generalInformationEN}
                                        onBlur={newContent => { setGeneralInformationEN(newContent); }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                  </div>
                                </>
                              )
                            }
                            <div className="row">
                              <div className="col-lg-12">
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button type='button' className='btn btn-light-primary me-4' onClick={() => setTab('BasicInfo')}>{t('Back')}</button>
                                  <button type='button' disabled={disable} className='btn btn-primary me-4' onClick={nextToFacilityAndServices}>
                                    <span className='indicator-label'>{t('Next')}</span>
                                    {loading && (
                                      <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                  </button>
                                  {' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content pt-3'>
                          <div className={clsx('tab-pane', { active: tab === 'FacilityAndServices' })}>
                            <div className="row">
                              <div className="col-lg-4 my-3">
                                {/* <!--begin::Label--> */}
                                <label className="required fs-5 form-label">{t('Facilities & Services')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <Select
                                  name='amenities[]'
                                  id='amenitiesListId'
                                  placeholder='Select Amenities'
                                  isSearchable={true}
                                  isMulti
                                  options={amenitiesList}
                                  value={amenitiesSelectedOptions}
                                  onChange={(e: any) => { setAmenitiesSelectedOptions(e); removeError("amenityId"); }}

                                />
                                <div className='text-danger fw-bold'>{error[0].amenityId}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className="col-lg-4 my-3">
                                {/* <!--begin::Label--> */}
                                <label className="required fs-5 form-label">{t('Room Type')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <Select
                                  name='roomType[]'
                                  id='roomTypeListId'
                                  placeholder={t('Select Room Type')}
                                  isSearchable={true}
                                  options={roomTypeList}
                                  value={roomTypeSelectedOptions}
                                  onChange={(e: any) => { setRoomTypeSelectedOptions(e); removeError("roomTypeId"); }}
                                />
                                <div className='text-danger fw-bold'>{error[0].roomTypeId}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className="col-lg-4 my-3">
                                {/* <!--begin::Label--> */}
                                <label className="required fs-5 form-label">{t('Bed Type')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <Select
                                  name='bedType[]'
                                  id='bedTypeListId'
                                  placeholder={t('Select Bed Type')}
                                  isSearchable={true}
                                  options={bedTypeList}
                                  value={bedTypeSelectedOptions}
                                  onChange={(e: any) => { setBedTypeSelectedOptions(e); removeError("bedTypeId"); }}
                                />
                                <div className='text-danger fw-bold'>{error[0].bedTypeId}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className="col-lg-4 my-3">
                                <label className="required fs-5 form-label">{t('Number Of Bathrooms')}</label>
                                <input type="text" name="numberOfBathroom" className="form-control mb-2" placeholder={t("Number Of Bathrooms")} value={numberOfBathroom} onChange={(e) => { setNumberOfBathroom(e.target.value); removeError("numberOfBathroom"); }} />
                                <div className='text-danger fw-bold'>{error[0].numberOfBathroom}</div>
                              </div>
                              <div className="col-lg-4 my-3">
                                {/* <!--begin::Label--> */}
                                <label className="required fs-5 form-label">{t('Bathroom Type')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <Select
                                  name='bathroomType[]'
                                  id='bathroomType'
                                  placeholder={t('Select Bathroom Type')}
                                  isSearchable={true}
                                  options={bathroomTypeList}
                                  value={bathroomTypeSelectedOptions}
                                  onChange={(e: any) => { setBathroomTypeSelectedOptions(e); removeError("bathroomTypeId"); }}
                                />
                                <div className='text-danger fw-bold'>{error[0].bathroomTypeId}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className="col-lg-4 my-3">
                                <div className="row">
                                  {/* <!--begin::Label--> */}
                                  <label className="fs-4 form-label">{t('Is smoking allowed in this studio?')}</label>
                                  {/* <!--end::Label--> */}
                                  <div className="col-4 my-2">
                                    <label className="d-flex text-start" data-kt-button="true">
                                      {/* <!--begin::Radio--> */}
                                      <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                        <input className="form-check-input" type="radio" name="isSmokingAllowed" value="Yes" checked={isSmokingAllowed == "Yes"} onChange={(e: any) => { setIsSmokingAllowed(e.target.value) }} />
                                      </span>
                                      {/* <!--end::Radio--> */}
                                      {/* <!--begin::Info--> */}
                                      <span className="ms-5">
                                        <span className="fs-4 fw-bold text-gray-800 d-block">{t('Yes')}</span>
                                      </span>
                                      {/* <!--end::Info--> */}
                                    </label>
                                  </div>
                                  <div className="col-4 my-2">
                                    <label className="d-flex text-start" data-kt-button="true">
                                      {/* <!--begin::Radio--> */}
                                      <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                        <input className="form-check-input" type="radio" name="isSmokingAllowed" value="No" checked={isSmokingAllowed == "No"} onChange={(e: any) => { setIsSmokingAllowed(e.target.value) }} />
                                      </span>
                                      {/* <!--end::Radio--> */}
                                      {/* <!--begin::Info--> */}
                                      <span className="ms-5">
                                        <span className="fs-4 fw-bold text-gray-800 d-block">{t('No')}</span>
                                      </span>
                                      {/* <!--end::Info--> */}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button type='button' className='btn btn-light-primary me-4' onClick={() => setTab('GeneralInfo')}>{t('Back')}</button>
                                  <button type='button' disabled={disable} className='btn btn-primary me-4' onClick={nextToPricingAndAvailability}>
                                    <span className='indicator-label'>{t('Next')}</span>
                                    {loading && (
                                      <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                  </button>
                                  {' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', { active: tab === 'PricingAndAvailability' })}>
                            <div className='card-header card-header-stretch overflow-auto'>
                              <ul
                                className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                                role='tablist'
                              >
                                <li className='nav-item'>
                                  <a
                                    className={clsx(`nav-link cursor-pointer`, { active: priceTab === 'RegularPrice' })}
                                    onClick={() => setPriceTab('RegularPrice')}
                                    role='tab'
                                  >
                                    {t('Regular Price')}
                                  </a>
                                </li>
                                <li className='nav-item'>
                                  <a
                                    className={clsx(`nav-link cursor-pointer`, { active: priceTab === 'SpecialPrice' })}
                                    onClick={() => setPriceTab('SpecialPrice')}
                                    role='tab'
                                  >
                                    {t('Special Price')}
                                  </a>
                                </li>
                                <li className='nav-item'>
                                  <a
                                    className={clsx(`nav-link cursor-pointer`, { active: priceTab === 'Availability' })}
                                    onClick={() => setPriceTab('Availability')}
                                    role='tab'
                                  >
                                    {t('Availability')}
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className='tab-content pt-3'>
                              <div className={clsx('tab-pane', { active: priceTab === 'RegularPrice' })}>
                                <div className="row">

                                </div>
                                <div className="row">
                                  <div className="col-lg-6 my-3">
                                    <div className="row">
                                      {/* <!--begin::Label--> */}
                                      <label className="fs-4 form-label required">{t('Booking Type')}</label>
                                      {/* <!--end::Label--> */}
                                      <div className="col-lg-4 col-5 my-2">
                                        <label className="d-flex text-start" data-kt-button="true">
                                          {/* <!--begin::Radio--> */}
                                          <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              name="byDay"
                                              value="true"
                                              checked={byDay}
                                              onChange={(e) => { handleByDayChange(e); removeError("bookingType") }}
                                            />
                                          </span>
                                          {/* <!--end::Radio--> */}
                                          {/* <!--begin::Info--> */}
                                          <span className="ms-5">
                                            <span className="fs-4 fw-bold text-gray-800 d-block">{t('By Day')}</span>
                                          </span>
                                          {/* <!--end::Info--> */}
                                        </label>
                                      </div>
                                    </div>
                                    <div className='text-danger fw-bold'>{error[0].bookingType}</div>
                                  </div>
                                </div>
                                <div className="row">
                                  {
                                    byDay && (
                                      <>
                                        <div className="col-lg-4 my-3">
                                          <PriceInput
                                            labelClass="required fs-5 form-label"
                                            label={t("Room Price (By Day)")}
                                            inputClass="form-control border-right-0"
                                            placeholder={t("Room Price")}
                                            value={baseCharge}
                                            onChange={(e: any) => { setBaseCharge(e); removeError("baseCharge"); }}
                                          />
                                          <div className='text-danger fw-bold'>{error[0].baseCharge}</div>
                                          <label className='fs-7 form-label text-end w-100 cursor-pointer' onClick={handleShowInfo}>
                                            <i className="fas fa-info-circle text-success fs-5"></i> {t('Insayr Commission Fees')}
                                          </label>
                                        </div>
                                        <div className="col-lg-4 my-3">
                                          <PriceInput
                                            labelClass="fs-6 form-label required"
                                            label={t("Charge per extra person")}
                                            inputClass="form-control mb-2 border-right-0"
                                            placeholder={t("Extra Charge")}
                                            value={extraAdultChargeByDay}
                                            onChange={(e: any) => { setExtraAdultChargeByDay(e); removeError("extraAdultChargeByDay"); }}
                                          />
                                          <div className='text-danger fw-bold'>{error[0].extraAdultChargeByDay}</div>
                                        </div>
                                        <div className="col-lg-4 my-3">
                                          {/* <!--begin::Label--> */}
                                          <label className="required fs-6 form-label">{t('Charge for kids under 3 yrs')}</label>
                                          {/* <!--end::Label--> */}
                                          {/* <!--begin::Input--> */}
                                          <input type="text" name="kidsCharge" className="form-control mb-2" placeholder={t("Charge For Kids")} disabled={true} defaultValue="Free" />
                                          {/* <!--end::Input--> */}
                                        </div>
                                      </>
                                    )
                                  }
                                </div>
                                <div className="row">
                                  <div className="col-lg-4 col-5 my-3">
                                    <label className="d-flex text-start" data-kt-button="true">
                                      {/* <!--begin::Radio--> */}
                                      <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          name="byHours"
                                          value="true"
                                          checked={byHours}
                                          onChange={(e) => { handleByHoursChange(e); removeError("bookingType") }}
                                        />
                                      </span>
                                      {/* <!--end::Radio--> */}
                                      {/* <!--begin::Info--> */}
                                      <span className="ms-5">
                                        <span className="fs-4 fw-bold text-gray-800 d-block">{t('By Hours')}</span>
                                      </span>
                                      {/* <!--end::Info--> */}
                                    </label>
                                  </div>
                                </div>
                                {
                                  byHours && (
                                    <>
                                      <div className="row">
                                        <div className="col-lg-12">
                                          <label className="fs-4 form-label">{t('Available Hours')}</label>
                                        </div>
                                        <div className="col-lg-4 col-6 my-3">
                                          {/* <!--begin::Label--> */}
                                          <label className="required fs-5 form-label">{t('From')}</label>
                                          {/* <!--end::Label--> */}
                                          <Flatpickr
                                            data-enable-time
                                            value={fromAvailableHours}
                                            onChange={(date) => {
                                              const formattedValue = handleInputChange({ target: { name: 'fromAvailableHours', value: handleTimeChange(date) } })
                                              setFromAvailableHours(formattedValue);
                                              removeError('fromAvailableHours');
                                            }}
                                            options={{
                                              enableTime: true,        // Enable time selection
                                              noCalendar: true,        // Hide the date picker, only show time
                                              dateFormat: 'H:i',       // 24-hour format (H:i)
                                              time_24hr: true,         // Enforces 24-hour format
                                              minuteIncrement: 60,     // 60-minute increments in dropdown
                                              allowInput: false,        // Allow typing custom times
                                            }}
                                            defaultValue={'00:00'}
                                            className="form-control mb-2"
                                          />
                                          <div className='text-danger fw-bold'>{error[0].fromAvailableHours}</div>
                                        </div>
                                        <div className="col-lg-4 col-6 my-3">
                                          {/* <!--begin::Label--> */}
                                          <label className="required fs-5 form-label">{t('To')}</label>
                                          {/* <!--end::Label--> */}
                                          <Flatpickr
                                            data-enable-time
                                            value={toAvailableHours}
                                            onChange={(date) => {
                                              const formattedValue = handleInputChange({ target: { name: 'toAvailableHours', value: handleTimeChange(date) } })
                                              setToAvailableHours(formattedValue);
                                              removeError('toAvailableHours');
                                            }}
                                            options={{
                                              enableTime: true,        // Enable time selection
                                              noCalendar: true,        // Hide the date picker, only show time
                                              dateFormat: 'H:i',       // 24-hour format (H:i)
                                              time_24hr: true,         // Enforces 24-hour format
                                              minuteIncrement: 60,     // 60-minute increments in dropdown
                                              allowInput: false,        // Allow typing custom times
                                            }}
                                            defaultValue={'00:00'}
                                            className="form-control mb-2"
                                          />
                                          <div className='text-danger fw-bold'>{error[0].toAvailableHours}</div>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-lg-4 my-3">
                                          <PriceInput
                                            labelClass="required fs-5 form-label"
                                            label={t("Room Price (By Hours)")}
                                            inputClass="form-control border-right-0"
                                            placeholder={t("Room Price")}
                                            value={baseChargeByHours}
                                            onChange={(e: any) => { setBaseChargeByHours(e); removeError("baseChargeByHours"); }}
                                          />
                                          <div className='text-danger fw-bold'>{error[0].baseChargeByHours}</div>
                                          <label className='fs-7 form-label text-end w-100 cursor-pointer' onClick={handleShowInfo}>
                                            <i className="fas fa-info-circle text-success fs-5"></i> {t('Insayr Commission Fees')}
                                          </label>
                                        </div>
                                        <div className="col-lg-4 my-3">
                                          <PriceInput
                                            labelClass="fs-6 form-label required"
                                            label={t("Charge per extra person")}
                                            inputClass="form-control mb-2 border-right-0"
                                            placeholder={t("Extra Charge")}
                                            value={extraAdultChargeByHours}
                                            onChange={(e: any) => { setExtraAdultChargeByHours(e); removeError("extraAdultChargeByHours"); }}
                                          />
                                          <div className='text-danger fw-bold'>{error[0].extraAdultChargeByHours}</div>
                                        </div>
                                        <div className="col-lg-4 my-3">
                                          {/* <!--begin::Label--> */}
                                          <label className="required fs-6 form-label">{t('Charge for kids under 3 yrs')}</label>
                                          {/* <!--end::Label--> */}
                                          {/* <!--begin::Input--> */}
                                          <input type="text" name="kidsCharge" className="form-control mb-2" placeholder={t("Charge For Kids")} disabled={true} defaultValue="Free" />
                                          {/* <!--end::Input--> */}
                                        </div>
                                      </div>
                                    </>
                                  )
                                }
                              </div>
                            </div>
                            <div className='tab-content pt-3'>
                              <div className={clsx('tab-pane', { active: priceTab === 'SpecialPrice' })}>
                                <div className="row mt-5">
                                  <div className="col-lg-12">
                                    <label className="fs-4 fw-bolder form-label">{t('Date Range')}</label>
                                  </div>
                                  <div className="col-lg-12">
                                    <b className='fs-1 text-gray-500'>*</b><label className="fs-6 text-gray-500 form-label"> {t('Fill the details only if you want to add special price, otherwise skip this.')}</label>
                                  </div>
                                  <div className="col-lg-4 my-3">
                                    {/* <!--begin::Label--> */}
                                    <label className="fs-5 required form-label">{t('From')}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <Flatpickr
                                      value={fromDate}
                                      onChange={([date]) => {
                                        setFromDate(date.toISOString()); clearValidationError('fromDate');
                                      }}
                                      options={{
                                        enableTime: true,
                                        dateFormat: "Y-m-d H:i"
                                      }}
                                      className='form-control mb-2'
                                      placeholder={t('Date')}
                                    />
                                    <div className='text-danger fw-bold'>{validationErrors[0].fromDate}</div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className="col-lg-4 my-3">
                                    {/* <!--begin::Label--> */}
                                    <label className="fs-5 required form-label">{t('To')}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <Flatpickr
                                      value={toDate}
                                      onChange={([date]) => {
                                        setToDate(date.toISOString()); clearValidationError('toDate');
                                      }}
                                      options={{
                                        enableTime: true,
                                        dateFormat: "Y-m-d H:i"
                                      }}
                                      className='form-control mb-2'
                                      placeholder={t('Date')}
                                    />
                                    <div className='text-danger fw-bold'>{validationErrors[0].toDate}</div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                {
                                  primaryLanguage == "English" && (
                                    <div className="row">
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="required fs-5 form-label">{t('Title (English)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="en_title" className="form-control mb-2" placeholder={t("Title")} value={en_title} onChange={(e) => { setEn_title(e.target.value); clearValidationError("en_title"); }} />
                                        <div className='text-danger fw-bold'>{validationErrors[0].en_title}</div>
                                        {/* <!--end::Input--> */}
                                      </div>
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="fs-5 form-label">{t('Title (Russian)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="ru_title" className="form-control mb-2" placeholder={t("Title")} value={ru_title} onChange={(e) => { setRu_title(e.target.value); }} />
                                        {/* <!--end::Input--> */}
                                      </div>
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="fs-5 form-label">{t('Title (Uzbek)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="uz_title" className="form-control mb-2" placeholder={t("Title")} value={uz_title} onChange={(e) => { setUz_title(e.target.value); }} />
                                        {/* <!--end::Input--> */}
                                      </div>
                                    </div>
                                  )
                                }
                                {
                                  primaryLanguage == "Russian" && (
                                    <div className="row">
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="required fs-5 form-label">{t('Title (Russian)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="ru_title" className="form-control mb-2" placeholder={t("Title")} value={ru_title} onChange={(e) => { setRu_title(e.target.value); clearValidationError("ru_title"); }} />
                                        <div className='text-danger fw-bold'>{validationErrors[0].ru_title}</div>
                                        {/* <!--end::Input--> */}
                                      </div>
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="fs-5 form-label">{t('Title (English)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="en_title" className="form-control mb-2" placeholder={t("Title")} value={en_title} onChange={(e) => { setEn_title(e.target.value); }} />
                                        {/* <!--end::Input--> */}
                                      </div>
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="fs-5 form-label">{t('Title (Uzbek)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="uz_title" className="form-control mb-2" placeholder={t("Title")} value={uz_title} onChange={(e) => { setUz_title(e.target.value); }} />
                                        {/* <!--end::Input--> */}
                                      </div>
                                    </div>
                                  )
                                }
                                {
                                  primaryLanguage == "Uzbek" && (
                                    <div className="row">
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="required fs-5 form-label">{t('Title (Uzbek)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="uz_title" className="form-control mb-2" placeholder={t("Title")} value={uz_title} onChange={(e) => { setUz_title(e.target.value); clearValidationError("uz_title"); }} />
                                        <div className='text-danger fw-bold'>{validationErrors[0].uz_title}</div>
                                        {/* <!--end::Input--> */}
                                      </div>
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="fs-5 form-label">{t('Title (Russian)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="ru_title" className="form-control mb-2" placeholder={t("Title")} value={ru_title} onChange={(e) => { setRu_title(e.target.value); }} />
                                        {/* <!--end::Input--> */}
                                      </div>
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="fs-5 form-label">{t('Title (English)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="en_title" className="form-control mb-2" placeholder={t("Title")} value={en_title} onChange={(e) => { setEn_title(e.target.value); }} />
                                        {/* <!--end::Input--> */}
                                      </div>
                                    </div>
                                  )
                                }
                                <div className="row">
                                  <div className="col-lg-6 border-end">
                                    <div className="row">
                                      <div className="col-lg-12 mb-3">
                                        <h4>{t('Hourly Type')}</h4>
                                      </div>
                                      <div className="col-lg-6 mb-3">
                                        <PriceInput
                                          labelClass="fs-6 form-label required"
                                          label={t("Monday")}
                                          inputClass="form-control mb-0 border-right-0"
                                          placeholder={t("Price")}
                                          value={hourlyMondayPrice}
                                          onChange={(e: any) => { setHourlyMondayPrice(e); clearValidationError("hourlyMondayPrice"); }}
                                        />
                                        <div className='text-danger fw-bold'>{validationErrors[0].hourlyMondayPrice}</div>
                                      </div>
                                      <div className="col-lg-6 mb-3">
                                        <PriceInput
                                          labelClass="fs-6 form-label required"
                                          label={t("Tuesday")}
                                          inputClass="form-control mb-0 border-right-0"
                                          placeholder={t("Price")}
                                          value={hourlyTuesdayPrice}
                                          onChange={(e: any) => { setHourlyTuesdayPrice(e); clearValidationError("hourlyTuesdayPrice"); }}
                                        />
                                        <div className='text-danger fw-bold'>{validationErrors[0].hourlyTuesdayPrice}</div>
                                      </div>
                                      <div className="col-lg-6 mb-3">
                                        <PriceInput
                                          labelClass="fs-6 form-label required"
                                          label={t("Wednesday")}
                                          inputClass="form-control mb-0 border-right-0"
                                          placeholder={t("Price")}
                                          value={hourlyWednedayPrice}
                                          onChange={(e: any) => { setHourlyWednesdayPrice(e); clearValidationError("hourlyWednedayPrice"); }}
                                        />
                                        <div className='text-danger fw-bold'>{validationErrors[0].hourlyWednedayPrice}</div>
                                      </div>
                                      <div className="col-lg-6 mb-3">
                                        <PriceInput
                                          labelClass="fs-6 form-label required"
                                          label={t("Thursday")}
                                          inputClass="form-control mb-0 border-right-0"
                                          placeholder={t("Price")}
                                          value={hourlyThurdayPrice}
                                          onChange={(e: any) => { setHourlyThursdayPrice(e); clearValidationError("hourlyThurdayPrice"); }}
                                        />
                                        <div className='text-danger fw-bold'>{validationErrors[0].hourlyThurdayPrice}</div>
                                      </div>
                                      <div className="col-lg-6 mb-3">
                                        <PriceInput
                                          labelClass="fs-6 form-label required"
                                          label={t("Friday")}
                                          inputClass="form-control mb-0 border-right-0"
                                          placeholder={t("Price")}
                                          value={hourlyFridayPrice}
                                          onChange={(e: any) => { setHourlyFridayPrice(e); clearValidationError("hourlyFridayPrice"); }}
                                        />
                                        <div className='text-danger fw-bold'>{validationErrors[0].hourlyFridayPrice}</div>
                                      </div>
                                      <div className="col-lg-6 mb-3">
                                        <PriceInput
                                          labelClass="fs-6 form-label required"
                                          label={t("Saturday")}
                                          inputClass="form-control mb-0 border-right-0"
                                          placeholder={t("Price")}
                                          value={hourlySaturdayPrice}
                                          onChange={(e: any) => { setHourlySaturdayPrice(e); clearValidationError("hourlySaturdayPrice"); }}
                                        />
                                        <div className='text-danger fw-bold'>{validationErrors[0].hourlySaturdayPrice}</div>
                                      </div>
                                      <div className="col-lg-6 mb-3">
                                        <PriceInput
                                          labelClass="fs-6 form-label required"
                                          label={t("Sunday")}
                                          inputClass="form-control mb-0 border-right-0"
                                          placeholder={t("Price")}
                                          value={hourlySundayPrice}
                                          onChange={(e: any) => { setHourlySundayPrice(e); clearValidationError("hourlySundayPrice"); }}
                                        />
                                        <div className='text-danger fw-bold'>{validationErrors[0].hourlySundayPrice}</div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="row">
                                      <div className="col-lg-12 mb-3">
                                        <h4>{t('Daily Type')}</h4>
                                      </div>
                                      <div className="col-lg-6 mb-3">
                                        <PriceInput
                                          labelClass="fs-6 form-label required"
                                          label={t("Monday")}
                                          inputClass="form-control mb-0 border-right-0"
                                          placeholder={t("Price")}
                                          value={dailyMondayPrice}
                                          onChange={(e: any) => { setDailyMondayPrice(e); clearValidationError("dailyMondayPrice"); }}
                                        />
                                        <div className='text-danger fw-bold'>{validationErrors[0].dailyMondayPrice}</div>
                                      </div>
                                      <div className="col-lg-6 mb-3">
                                        <PriceInput
                                          labelClass="fs-6 form-label required"
                                          label={t("Tuesday")}
                                          inputClass="form-control mb-0 border-right-0"
                                          placeholder={t("Price")}
                                          value={dailyTuesdayPrice}
                                          onChange={(e: any) => { setDailyTuesdayPrice(e); clearValidationError("dailyTuesdayPrice"); }}
                                        />
                                        <div className='text-danger fw-bold'>{validationErrors[0].dailyTuesdayPrice}</div>
                                      </div>
                                      <div className="col-lg-6 mb-3">
                                        <PriceInput
                                          labelClass="fs-6 form-label required"
                                          label={t("Wednesday")}
                                          inputClass="form-control mb-0 border-right-0"
                                          placeholder={t("Price")}
                                          value={dailyWednedayPrice}
                                          onChange={(e: any) => { setDailyWednesdayPrice(e); clearValidationError("dailyWednedayPrice"); }}
                                        />
                                        <div className='text-danger fw-bold'>{validationErrors[0].dailyWednedayPrice}</div>
                                      </div>
                                      <div className="col-lg-6 mb-3">
                                        <PriceInput
                                          labelClass="fs-6 form-label required"
                                          label={t("Thursday")}
                                          inputClass="form-control mb-0 border-right-0"
                                          placeholder={t("Price")}
                                          value={dailyThurdayPrice}
                                          onChange={(e: any) => { setDailyThursdayPrice(e); clearValidationError("dailyThurdayPrice"); }}
                                        />
                                        <div className='text-danger fw-bold'>{validationErrors[0].dailyThurdayPrice}</div>
                                      </div>
                                      <div className="col-lg-6 mb-3">
                                        <PriceInput
                                          labelClass="fs-6 form-label required"
                                          label={t("Friday")}
                                          inputClass="form-control mb-0 border-right-0"
                                          placeholder={t("Price")}
                                          value={dailyFridayPrice}
                                          onChange={(e: any) => { setDailyFridayPrice(e); clearValidationError("dailyFridayPrice"); }}
                                        />
                                        <div className='text-danger fw-bold'>{validationErrors[0].dailyFridayPrice}</div>
                                      </div>
                                      <div className="col-lg-6 mb-3">
                                        <PriceInput
                                          labelClass="fs-6 form-label required"
                                          label={t("Saturday")}
                                          inputClass="form-control mb-0 border-right-0"
                                          placeholder={t("Price")}
                                          value={dailySaturdayPrice}
                                          onChange={(e: any) => { setDailySaturdayPrice(e); clearValidationError("dailySaturdayPrice"); }}
                                        />
                                        <div className='text-danger fw-bold'>{validationErrors[0].dailySaturdayPrice}</div>
                                      </div>
                                      <div className="col-lg-6 mb-3">
                                        <PriceInput
                                          labelClass="fs-6 form-label required"
                                          label={t("Sunday")}
                                          inputClass="form-control mb-0 border-right-0"
                                          placeholder={t("Price")}
                                          value={dailySundayPrice}
                                          onChange={(e: any) => { setDailySundayPrice(e); clearValidationError("dailySundayPrice"); }}
                                        />
                                        <div className='text-danger fw-bold'>{validationErrors[0].dailySundayPrice}</div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12 d-flex justify-content-end align-items-end">
                                    <button className='btn btn-primary mb-3' onClick={handleSave}>
                                      {editIndex > -1 ? t('Update') : t('Save')}
                                    </button>
                                  </div>
                                </div>
                                <div className="card">
                                  {/* begin::Body */}
                                  <div className='card-body pt-5 p-0'>
                                    {/* begin::Table container */}
                                    <div className='table-responsive'>
                                      {/* begin::Table */}
                                      <table className='table align-middle gs-0 gy-4'>
                                        {/* begin::Table head */}
                                        <thead>
                                          <tr className='fw-bold text-muted bg-light'>
                                            <th className='ps-4 min-w-325px rounded-start'>{t('Date Range')}</th>
                                            <th className='min-w-150px'>{t('Title')}</th>
                                            <th className='min-w-150px'>{t('Type')}</th>
                                            <th className='min-w-150px'>{t('Mon')}</th>
                                            <th className='min-w-150px'>{t('Tue')}</th>
                                            <th className='min-w-150px'>{t('Wed')}</th>
                                            <th className='min-w-150px'>{t('Thu')}</th>
                                            <th className='min-w-150px'>{t('Fri')}</th>
                                            <th className='min-w-150px'>{t('Sat')}</th>
                                            <th className='min-w-150px'>{t('Sun')}</th>
                                            <th className='min-w-200px rounded-end'>{t('Action')}</th>
                                          </tr>
                                        </thead>
                                        {/* end::Table head */}
                                        {/* begin::Table body */}
                                        <tbody>
                                          {
                                            specialPrice.map((item: any, index: any) => {
                                              return (
                                                <tr className='border-bottom' key={index}>
                                                  <td>
                                                    <div className='d-flex align-items-center'>
                                                      <div className='d-flex justify-content-start flex-column'>
                                                        <h6 className='fw-bold mb-1 fs-7'>
                                                          {formatDate(item.fromDate)} to {formatDate(item.toDate)}
                                                        </h6>
                                                      </div>
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {
                                                        primaryLanguage == 'English' && item.en_title
                                                      }
                                                      {
                                                        primaryLanguage == 'Russian' && item.ru_title
                                                      }
                                                      {
                                                        primaryLanguage == 'Uzbek' && item.uz_title
                                                      }
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>{item.hourlyType}</h6>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>{item.dailyType}</h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.hourlyMondayPrice}
                                                    </h6>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.dailyMondayPrice}
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.hourlyTuesdayPrice}
                                                    </h6>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.dailyTuesdayPrice}
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.hourlyWednedayPrice}
                                                    </h6>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.dailyWednedayPrice}
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.hourlyThurdayPrice}
                                                    </h6>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.dailyThurdayPrice}
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.hourlyFridayPrice}
                                                    </h6>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.dailyFridayPrice}
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.hourlySaturdayPrice}
                                                    </h6>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.dailySaturdayPrice}
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.hourlySundayPrice}
                                                    </h6>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.dailySundayPrice}
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <button
                                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                      onClick={() => handleEdit(index)}
                                                    >
                                                      <KTIcon iconName='pencil' className='fs-3' />
                                                    </button>
                                                    <button className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                      onClick={() => handleRemove(index)}
                                                    >
                                                      <KTIcon iconName='trash' className='fs-3' />
                                                    </button>
                                                  </td>
                                                </tr>
                                              )
                                            })
                                          }
                                        </tbody>
                                        {/* end::Table body */}
                                      </table>
                                      {
                                        specialPrice.length == 0 && (
                                          <div className="row">
                                            <div className="col-lg-12 text-center">
                                              <label className="fs-6 text-gray-500 my-5 text-center">{t('No Records Found.')}</label>
                                            </div>
                                          </div>
                                        )
                                      }
                                      {/* end::Table */}
                                    </div>
                                    {/* end::Table container */}
                                  </div>
                                  {/* begin::Body */}
                                </div>
                              </div>
                            </div>
                            <div className='tab-content pt-3'>
                              <div className={clsx('tab-pane', { active: priceTab === 'Availability' })}>
                                <div className="row">
                                  <div className="col-lg-4 my-3">
                                    {/* <!--begin::Label--> */}
                                    <label className="required fs-5 form-label">{t('Available rooms of the same type')}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input type="text" name="availableRoom" className="form-control mb-2" placeholder={t("Available Room")} value={availableRoom} onChange={(e) => { setAvailableRoom(e.target.value); removeError("availableRoom"); }} />
                                    <div className='text-danger fw-bold'>{error[0].availableRoom}</div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className="col-lg-12">
                                    <label className="fs-2 fw-bolder form-label">{t('Available Dates')}</label>
                                  </div>
                                  <div className="col-lg-12 my-3">
                                    <span className='fw-bolder fs-5 form-label'>{t('*Note:')}<span className="fs-7 form-label" style={{ fontStyle: 'italic' }}> {t('First select availability types, then you can set availability from date range of above start date and end date and click on apply button. Or you can directly click on calender date box for single date selection.')}</span></span>
                                  </div>
                                  <div className="col-lg-4 my-3">
                                    {/* <!--begin::Label--> */}
                                    <label className="fs-5 form-label">{t('Availability Types')}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <Select
                                      name='availableType[]'
                                      id='availableTypeList'
                                      placeholder={t('Select Availability Types')}
                                      isSearchable={true}
                                      options={availableTypeList}
                                      value={availableTypeSelectedOptions}
                                      onChange={(e: any) => { setAvailableTypeSelectedOptions(e); }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className="col-lg-8 my-3">
                                    <div className="row">
                                      <div className="col-lg">
                                        {/* <!--begin::Label--> */}
                                        <label className="fs-5 form-label">{t('Start Date')}</label>
                                        {/* <!--end::Label--> */}
                                        <input type="date" name="startAvailableDate" className="form-control mb-2" value={startAvailableDate} onChange={(e) => { setStartAvailableDate(e.target.value); removeError("startAvailableDate"); }} />
                                      </div>
                                      <div className='col-lg'>
                                        {/* <!--begin::Label--> */}
                                        <label className="fs-5 form-label">{t('End Date')}</label>
                                        {/* <!--end::Label--> */}
                                        <input type="date" name="endAvailableDate" className="form-control mb-2" value={endAvailableDate} onChange={(e) => { setEndAvailableDate(e.target.value); removeError("endAvailableDate"); }} />
                                      </div>
                                      <div className="col-lg d-flex align-items-end">
                                        <button className='btn btn-primary mb-2 mx-1' onClick={ApplyAvailableDates}>{t('Apply')}</button>
                                        <button className='btn btn-danger mb-2 mx-1' onClick={clearAvailableDates}>{t('Clear')}</button>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12 my-5">
                                    <Calendar
                                      localizer={localizer}
                                      events={events}
                                      startAccessor="start"
                                      endAccessor="end"
                                      selectable
                                      onSelectSlot={handleSelectSlot}
                                      style={{ height: 500 }}
                                      eventPropGetter={eventStyleGetter}
                                      onSelectEvent={(event: CustomEvent) => handleRemoveEvent(event)}
                                      views={[Views.MONTH]}
                                    />
                                  </div>
                                  <div className='text-danger fw-bold'>{error[0].availableDate}</div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-12">
                                    <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                      <button type='button' className='btn btn-light-primary me-4' onClick={() => setTab('FacilityAndServices')}>{t('Back')}</button>
                                      <button type='button' disabled={disable} className='btn btn-primary me-4' onClick={nextToRoomPhotos}>
                                        <span className='indicator-label'>{t('Next')}</span>
                                        {loading && (
                                          <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                        )}
                                      </button>
                                      {' '}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content pt-3'>
                          <div className={clsx('tab-pane', { active: tab === 'RoomPhotos' })}>
                            <div className="row">
                              <div className="col-lg-12">
                                {/* <!--begin::Label--> */}
                                <label className="fs-5 form-label">{t('Upload images')}</label>
                                {/* <!--end::Label--> */}
                                <br />
                                <input
                                  ref={inputfileRef}
                                  style={{ display: 'none' }}
                                  className='modaldocument'
                                  type='file'
                                  onChange={handleImageChange}
                                  accept='image/*'
                                  multiple
                                />
                                <span className='btn btn-light text-primary cursor-pointer ' onClick={handleTextClick}> {t('Attach Images')}</span>
                                <div className='text-danger fw-bold'>{error[0].inputImage}</div>
                                <div className="row mt-3">
                                  <SortableUploadedImages
                                    type='room'
                                    images={uploadedImage}
                                    onReorder={(images) => setUploadedImage(images as any)}
                                    onRemove={handleRemoveImage}
                                    adminId={adminId}
                                    idKey='hotelmediaId'
                                    droppableId='uploadedRoomImageList'
                                  />
                                  <SortableNewImages
                                    images={inputImage}
                                    onReorder={(images) => setInputImage(images as any)}
                                    onRemove={handleRemove1}
                                    droppableId='newRoomImageList'
                                  />
                                </div>
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                            <div className="row">
                              <div className="col-lg-12">
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button type='button' className='btn btn-light-primary me-4' onClick={() => setTab('PricingAndAvailability')}>{t('Back')}</button>
                                  <button type='button' disabled={disable} className='btn btn-primary me-4' onClick={() => { if (editRoomId !== "") { editRoomApi(); } else { addRoomApi(); } }}>
                                    <span className='indicator-label'>{t('Submit')}</span>
                                    {loading && (
                                      <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                  </button>
                                  {' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!--end::Controls--> */}
                    </div>
                    {/* <!--end::Dropzone--> */}
                  </div>
                  {/* <!--end::Input group--> */}
                </div>
                {/* <!--end::Modal body--> */}
              </div>
              {/* <!--end::Form--> */}
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        show={showInfo}
        onHide={handleCloseInfo}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal fade show" id="kt_modal_upload" tabIndex={-1} style={{ display: "block" }} aria-modal="true" role="dialog">
          {/* <!--begin::Modal dialog--> */}
          <div className="modal-dialog modal-dialog-centered mw-500px">
            {/* <!--begin::Modal content--> */}
            <div className="modal-content bg-light-success">
              {/* <!--begin::Form--> */}
              <div className="form" id="kt_modal_upload_form">
                {/* <!--begin::Modal header--> */}
                <div className="modal-header d-flex justify-content-between border-bottom border-1 border-success">
                  {/* <!--begin::Modal title--> */}
                  <h2 className="fw-bold">{t('Information')}</h2>
                  {/* <!--end::Modal title--> */}
                  {/* <!--begin::Close--> */}
                  <div className="btn btn-icon btn-sm btn-active-icon-primary" onClick={handleCloseInfo}>
                    <i className="ki-duotone ki-cross fs-1"><span className="path1"></span><span className="path2"></span></i>
                  </div>
                  {/* <!--end::Close--> */}
                </div>
                {/* <!--end::Modal header--> */}
                {/* <!--begin::Modal body--> */}
                <div className="modal-body pt-10 pb-15 px-lg-17">
                  <h2 className="fw-bold">{t('Insayr Commission Fees')}</h2>
                  <h6 className="mt-5">{t('We charge agreed commission fee from the amount you set in the price column')}</h6>
                  {/* <!--begin::Input group--> */}
                  <div className="form-group my-4">
                    {/* <!--begin::Dropzone--> */}
                    <div className="dropzone dropzone-queue mb-2" id="kt_modal_upload_dropzone">
                      <ul>
                        <li className="fs-5 fw-bold">{t('Platform Maintenance')} &amp; {t('Growth')}</li>
                        <li className="fs-6 list-style-none">{t('The commission fees help us maintain and improve the platform, ensuring smooth operations, better features, and a larger audience for your listings.')}</li>
                        <li className="fs-5 fw-bold mt-5">{t('Marketing')} &amp; {t('Promotions')}</li>
                        <li className="fs-6 list-style-none">{t('We reinvest a portion of the fees into marketing campaigns to drive more traffic to your listings and increase your booking opportunities.')}</li>
                        <li className="fs-5 fw-bold">{t('User Support')} &amp; {t('Trust')}</li>
                        <li className="fs-6 list-style-none">{t('Our fees help provide 24/7 support to users and vendors, building trust and ensuring a seamless experience for all.')}</li>
                        <li className="fs-5 fw-bold">{t('Continuous Innovation')}</li>
                        <li className="fs-6 list-style-none">{t('Commission fees fund new tools and features, helping you better manage your business and attract more customers.')}</li>
                      </ul>
                    </div>
                    {/* <!--end::Dropzone--> */}
                  </div>
                  {/* <!--end::Input group--> */}
                </div>
                {/* <!--end::Modal body--> */}
              </div>
              {/* <!--end::Form--> */}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export { ViewRooms }
